var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConcordianew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "750px",
    height: "290px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f4db",
    d: "M -0.5,-0.5 C 42.5,-0.5 85.5,-0.5 128.5,-0.5C 199.028,37.7699 269.695,76.1032 340.5,114.5C 341.485,118.634 341.818,122.968 341.5,127.5C 234.774,137.507 128.107,148.173 21.5,159.5C 17.1311,159.467 12.7978,159.8 8.5,160.5C 8.5,162.833 8.5,165.167 8.5,167.5C 8.5,176.167 8.5,184.833 8.5,193.5C 5.5,193.5 2.5,193.5 -0.5,193.5C -0.5,128.833 -0.5,64.1667 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2abbb3",
    d: "M 128.5,-0.5 C 156.167,-0.5 183.833,-0.5 211.5,-0.5C 253.483,33.4856 295.149,67.8189 336.5,102.5C 337.446,103.931 338.612,105.264 340,106.5C 340.497,109.146 340.664,111.813 340.5,114.5C 269.695,76.1032 199.028,37.7699 128.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4da",
    d: "M 211.5,-0.5 C 227.5,-0.5 243.5,-0.5 259.5,-0.5C 272.486,15.8169 285.82,31.8169 299.5,47.5C 297.176,50.8043 294.843,54.1376 292.5,57.5C 297.792,58.4948 303.125,58.8282 308.5,58.5C 317.453,69.7956 326.453,81.1289 335.5,92.5C 336.7,93.2916 338.033,93.2916 339.5,92.5C 340.338,92.8417 340.672,93.5084 340.5,94.5C 339.178,94.33 338.011,94.6634 337,95.5C 336.503,97.8098 336.337,100.143 336.5,102.5C 295.149,67.8189 253.483,33.4856 211.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2ebcb4",
    d: "M 259.5,-0.5 C 272.5,-0.5 285.5,-0.5 298.5,-0.5C 299.086,1.83984 300.086,4.00651 301.5,6C 298.774,6.18156 296.107,6.68156 293.5,7.5C 298.964,15.5979 304.297,23.7646 309.5,32C 306.353,37.3084 303.02,42.4751 299.5,47.5C 285.82,31.8169 272.486,15.8169 259.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#33bdb4",
    d: "M 430.5,-0.5 C 443.167,-0.5 455.833,-0.5 468.5,-0.5C 461.5,8.16667 454.5,16.8333 447.5,25.5C 446.427,24.7494 446.26,23.7494 447,22.5C 450.167,16.8333 453.333,11.1667 456.5,5.5C 450.167,4.16667 443.833,4.16667 437.5,5.5C 435.921,8.9939 434.087,12.3272 432,15.5C 430.517,12.6766 429.017,9.84324 427.5,7C 428.651,4.53509 429.651,2.03509 430.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4db",
    d: "M 468.5,-0.5 C 484.167,-0.5 499.833,-0.5 515.5,-0.5C 498.525,13.4701 481.525,27.4701 464.5,41.5C 446.319,56.4154 427.985,71.082 409.5,85.5C 409.454,81.7651 407.787,80.4317 404.5,81.5C 403.756,84.443 403.256,87.443 403,90.5C 402.5,89.5 402,88.5 401.5,87.5C 402.766,85.0276 402.766,82.6943 401.5,80.5C 401.167,80.5 400.833,80.5 400.5,80.5C 400.5,79.5 400.5,78.5 400.5,77.5C 401.151,78.0906 401.818,78.7573 402.5,79.5C 403.107,79.3764 403.44,79.0431 403.5,78.5C 410.885,70.723 417.552,62.3897 423.5,53.5C 428.532,55.3699 433.865,56.0366 439.5,55.5C 439.795,48.4122 439.462,41.4122 438.5,34.5C 440.262,30.6383 442.262,26.9717 444.5,23.5C 445.309,25.0133 445.476,26.6799 445,28.5C 446.045,27.6266 446.878,26.6266 447.5,25.5C 454.5,16.8333 461.5,8.16667 468.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2abbb3",
    d: "M 515.5,-0.5 C 544.167,-0.5 572.833,-0.5 601.5,-0.5C 563.477,21.1811 524.81,41.8478 485.5,61.5C 485.196,59.3789 485.196,57.0456 485.5,54.5C 485.192,53.6919 484.692,53.0253 484,52.5C 483.333,53.8333 482.667,53.8333 482,52.5C 481.593,56.3305 480.26,56.9972 478,54.5C 475.333,55.1667 472.667,55.8333 470,56.5C 469.358,54.2381 468.525,52.0715 467.5,50C 467.833,49.6667 468.167,49.3333 468.5,49C 465.641,47.3091 464.308,44.8091 464.5,41.5C 481.525,27.4701 498.525,13.4701 515.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f4db",
    d: "M 601.5,-0.5 C 650.833,-0.5 700.167,-0.5 749.5,-0.5C 749.5,64.1667 749.5,128.833 749.5,193.5C 746.167,193.5 742.833,193.5 739.5,193.5C 739.665,190.482 739.498,187.482 739,184.5C 737.757,185.336 736.59,185.003 735.5,183.5C 736.32,181.889 737.654,181.222 739.5,181.5C 739.5,179.5 739.5,177.5 739.5,175.5C 739.5,174.167 739.5,172.833 739.5,171.5C 739.817,168.428 739.484,165.428 738.5,162.5C 737.402,163.615 736.235,163.615 735,162.5C 734.05,163.022 733.216,163.689 732.5,164.5C 732.089,163.738 731.923,162.738 732,161.5C 730.887,162.711 729.72,162.711 728.5,161.5C 727.478,161.855 726.811,162.522 726.5,163.5C 726.44,164.043 726.107,164.376 725.5,164.5C 724.289,163.726 724.289,162.893 725.5,162C 624.3,150.847 522.967,140.68 421.5,131.5C 417.382,130.291 413.049,129.624 408.5,129.5C 408.5,127.167 408.5,124.833 408.5,122.5C 518.577,111.156 628.91,100.156 739.5,89.5C 739.497,64.1363 739.164,38.4697 738.5,12.5C 628.107,45.6442 518.107,78.6442 408.5,111.5C 408.372,109.345 408.872,107.345 410,105.5C 412.123,105.034 413.623,103.867 414.5,102C 413.713,99.9011 413.38,97.7345 413.5,95.5C 414.29,96.6085 414.79,97.9419 415,99.5C 429.493,91.6015 443.493,84.2682 457,77.5C 457.065,75.1167 457.898,74.45 459.5,75.5C 466.276,72.7798 472.276,69.7798 477.5,66.5C 480.568,65.3087 483.235,63.642 485.5,61.5C 524.81,41.8478 563.477,21.1811 601.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e3c6",
    d: "M 298.5,-0.5 C 307.5,-0.5 316.5,-0.5 325.5,-0.5C 326.15,1.43525 326.483,3.43525 326.5,5.5C 335.167,5.5 343.833,5.5 352.5,5.5C 352.5,3.5 352.5,1.5 352.5,-0.5C 360.167,-0.5 367.833,-0.5 375.5,-0.5C 375.5,1.5 375.5,3.5 375.5,5.5C 377.792,5.24358 379.959,5.57692 382,6.5C 383.466,11.2316 385.133,15.8982 387,20.5C 388.732,12.4351 393.565,7.2684 401.5,5C 402.244,3.1852 402.911,1.35187 403.5,-0.5C 412.5,-0.5 421.5,-0.5 430.5,-0.5C 429.651,2.03509 428.651,4.53509 427.5,7C 429.017,9.84324 430.517,12.6766 432,15.5C 434.087,12.3272 435.921,8.9939 437.5,5.5C 443.833,4.16667 450.167,4.16667 456.5,5.5C 453.333,11.1667 450.167,16.8333 447,22.5C 446.26,23.7494 446.427,24.7494 447.5,25.5C 446.878,26.6266 446.045,27.6266 445,28.5C 445.476,26.6799 445.309,25.0133 444.5,23.5C 446.857,18.1255 449.19,12.7922 451.5,7.5C 447.116,7.17443 442.783,7.50776 438.5,8.5C 436.318,12.8644 434.151,17.1978 432,21.5C 429.833,17.1667 427.667,12.8333 425.5,8.5C 423.926,7.36912 422.259,7.20245 420.5,8C 422.976,9.30878 424.976,11.1421 426.5,13.5C 424.283,16.7729 421.95,19.9396 419.5,23C 421.802,27.1037 423.968,31.2704 426,35.5C 426.499,41.4908 426.666,47.4908 426.5,53.5C 430.167,53.5 433.833,53.5 437.5,53.5C 437.177,46.9779 437.51,40.6446 438.5,34.5C 439.462,41.4122 439.795,48.4122 439.5,55.5C 433.865,56.0366 428.532,55.3699 423.5,53.5C 423.633,48.7283 422.3,48.5616 419.5,53C 413.075,55.4186 406.408,56.5853 399.5,56.5C 399.276,58.7867 398.609,60.9534 397.5,63C 400.488,67.7843 402.488,72.951 403.5,78.5C 403.44,79.0431 403.107,79.3764 402.5,79.5C 401.818,78.7573 401.151,78.0906 400.5,77.5C 400.575,68.928 396.909,62.5947 389.5,58.5C 388.609,57.8902 387.609,57.5569 386.5,57.5C 382.433,55.9462 378.1,55.2796 373.5,55.5C 371.833,55.5 370.167,55.5 368.5,55.5C 367.209,55.2627 366.209,55.596 365.5,56.5C 363.847,56.6596 362.514,57.3263 361.5,58.5C 360.167,58.8333 358.833,59.1667 357.5,59.5C 358.11,58.609 358.443,57.609 358.5,56.5C 349.014,55.5062 339.348,55.1729 329.5,55.5C 329.831,48.1365 329.497,40.8032 328.5,33.5C 327.463,36.5371 325.463,38.5371 322.5,39.5C 322.634,41.2915 322.301,42.9582 321.5,44.5C 319.095,48.9726 316.429,53.306 313.5,57.5C 311.955,58.4519 310.288,58.7852 308.5,58.5C 303.125,58.8282 297.792,58.4948 292.5,57.5C 294.843,54.1376 297.176,50.8043 299.5,47.5C 303.02,42.4751 306.353,37.3084 309.5,32C 304.297,23.7646 298.964,15.5979 293.5,7.5C 296.107,6.68156 298.774,6.18156 301.5,6C 300.086,4.00651 299.086,1.83984 298.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2cbcb3",
    d: "M 375.5,-0.5 C 384.833,-0.5 394.167,-0.5 403.5,-0.5C 402.911,1.35187 402.244,3.1852 401.5,5C 393.565,7.2684 388.732,12.4351 387,20.5C 385.133,15.8982 383.466,11.2316 382,6.5C 379.959,5.57692 377.792,5.24358 375.5,5.5C 375.5,3.5 375.5,1.5 375.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2dbcb4",
    d: "M 325.5,-0.5 C 334.5,-0.5 343.5,-0.5 352.5,-0.5C 352.5,1.5 352.5,3.5 352.5,5.5C 343.833,5.5 335.167,5.5 326.5,5.5C 326.483,3.43525 326.15,1.43525 325.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b5ab93",
    d: "M 357.5,8.5 C 344.323,8.17119 331.323,8.50452 318.5,9.5C 317.957,9.44001 317.624,9.10667 317.5,8.5C 330.994,7.17464 344.327,7.17464 357.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c3e30",
    d: "M 400.5,7.5 C 405.913,7.22877 411.246,7.72877 416.5,9C 419.21,10.0152 421.543,11.5152 423.5,13.5C 421.494,16.0048 419.328,18.3381 417,20.5C 412.79,17.9946 408.29,17.1613 403.5,18C 402.978,18.5613 402.645,19.228 402.5,20C 403.34,21.7674 404.673,23.1007 406.5,24C 420.306,25.8192 425.472,33.3192 422,46.5C 420.127,48.7089 417.96,50.5422 415.5,52C 406.842,54.557 398.509,53.8903 390.5,50C 389.313,48.9805 388.313,47.8139 387.5,46.5C 389.202,43.9633 391.369,41.9633 394,40.5C 399.121,43.3646 404.454,44.0312 410,42.5C 410.72,40.8876 410.554,39.3876 409.5,38C 404.669,36.3895 400.003,34.3895 395.5,32C 390.247,26.7345 389.081,20.5678 392,13.5C 394.671,11.0976 397.505,9.09757 400.5,7.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c3e30",
    d: "M 444.5,23.5 C 442.262,26.9717 440.262,30.6383 438.5,34.5C 437.51,40.6446 437.177,46.9779 437.5,53.5C 433.833,53.5 430.167,53.5 426.5,53.5C 426.666,47.4908 426.499,41.4908 426,35.5C 423.968,31.2704 421.802,27.1037 419.5,23C 421.95,19.9396 424.283,16.7729 426.5,13.5C 424.976,11.1421 422.976,9.30878 420.5,8C 422.259,7.20245 423.926,7.36912 425.5,8.5C 427.667,12.8333 429.833,17.1667 432,21.5C 434.151,17.1978 436.318,12.8644 438.5,8.5C 442.783,7.50776 447.116,7.17443 451.5,7.5C 449.19,12.7922 446.857,18.1255 444.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4a3c2e",
    d: "M 357.5,8.5 C 357.5,11.8333 357.5,15.1667 357.5,18.5C 352.833,18.5 348.167,18.5 343.5,18.5C 343.5,30.1667 343.5,41.8333 343.5,53.5C 339.5,53.5 335.5,53.5 331.5,53.5C 331.5,41.8333 331.5,30.1667 331.5,18.5C 328.753,18.8134 326.086,18.48 323.5,17.5C 321.822,14.8053 320.156,12.1386 318.5,9.5C 331.323,8.50452 344.323,8.17119 357.5,8.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4c3e30",
    d: "M 382.5,47.5 C 376.758,45.2843 370.758,44.951 364.5,46.5C 363.833,48.5 363.167,50.5 362.5,52.5C 358.167,53.8333 353.833,53.8333 349.5,52.5C 355.098,38.2058 360.598,23.8725 366,9.5C 370.737,8.53082 375.57,8.19749 380.5,8.5C 383.67,18.5079 387.336,28.3413 391.5,38C 388.296,41.0359 385.296,44.2026 382.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d3f31",
    d: "M 322.5,39.5 C 318.691,44.4326 315.358,49.766 312.5,55.5C 307.167,56.8333 301.833,56.8333 296.5,55.5C 302.044,47.7932 307.377,39.9598 312.5,32C 308.004,24.0086 303.004,16.3419 297.5,9C 303.084,8.19443 308.584,8.3611 314,9.5C 318.5,16.5 323,23.5 327.5,30.5C 325.555,33.3933 323.889,36.3933 322.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2ebcb4",
    d: "M 408.5,122.5 C 408.5,118.833 408.5,115.167 408.5,111.5C 518.107,78.6442 628.107,45.6442 738.5,12.5C 739.164,38.4697 739.497,64.1363 739.5,89.5C 628.91,100.156 518.577,111.156 408.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a29781",
    d: "M 357.5,18.5 C 353.366,19.4849 349.032,19.8182 344.5,19.5C 344.828,31.0123 344.495,42.3456 343.5,53.5C 343.5,41.8333 343.5,30.1667 343.5,18.5C 348.167,18.5 352.833,18.5 357.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#35beb5",
    d: "M 346.5,21.5 C 349.187,21.3359 351.854,21.5026 354.5,22C 355.622,25.4085 355.789,28.9085 355,32.5C 352.344,39.0721 349.678,45.7388 347,52.5C 346.5,42.172 346.334,31.8387 346.5,21.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d5d3b8",
    d: "M 372.5,22.5 C 375.334,26.6642 377.001,31.3308 377.5,36.5C 374.5,36.5 371.5,36.5 368.5,36.5C 369.63,31.7756 370.964,27.1089 372.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d78284",
    d: "M 11.5,26.5 C 11.2322,28.099 11.5655,29.4324 12.5,30.5C 11.956,36.2428 12.956,36.5761 15.5,31.5C 16.3636,30.3117 17.3636,29.1451 18.5,28C 18.1667,27.6667 17.8333,27.3333 17.5,27C 19.1686,26.8782 20.8353,27.2115 22.5,28C 20.9559,28.2896 19.6226,28.9563 18.5,30C 19.7155,32.0955 20.5488,31.9288 21,29.5C 21.3333,30.8333 21.6667,32.1667 22,33.5C 22.6667,32.1667 23.3333,32.1667 24,33.5C 24.4512,31.0712 25.2845,30.9045 26.5,33C 22.4593,36.7922 23.2926,39.2922 29,40.5C 30.101,39.7087 30.9344,39.7087 31.5,40.5C 28.8508,42.5501 25.8508,43.7167 22.5,44C 23.8333,44.6667 23.8333,45.3333 22.5,46C 26.5151,44.8064 27.1817,45.6397 24.5,48.5C 22.5045,50.4236 20.5045,50.5903 18.5,49C 19.5,48.6667 20.5,48.3333 21.5,48C 19.9371,47.2411 18.9371,46.0744 18.5,44.5C 18.762,43.0222 18.4287,41.6888 17.5,40.5C 16.4593,42.9913 15.6259,42.9913 15,40.5C 14.6667,41.1667 14.3333,41.8333 14,42.5C 12.7978,40.447 12.4644,38.447 13,36.5C 12.2635,38.596 11.0968,40.2627 9.5,41.5C 8.17159,40.0903 8.50492,38.9236 10.5,38C 9.48444,37.4806 8.81777,36.6473 8.5,35.5C 8.65321,31.2569 8.81988,26.9236 9,22.5C 9.20041,24.3197 10.0337,25.653 11.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf3c4f",
    d: "M 55.5,31.5 C 55.9926,33.8056 56.3259,36.139 56.5,38.5C 55.325,38.281 54.325,38.6143 53.5,39.5C 54.5,41.1667 55.5,42.8333 56.5,44.5C 55.2137,46.2901 53.7137,47.9568 52,49.5C 51.6667,49.1667 51.3333,48.8333 51,48.5C 50.5,49.5 50,50.5 49.5,51.5C 50.8333,51.8333 52.1667,52.1667 53.5,52.5C 52.675,53.3857 51.675,53.719 50.5,53.5C 50.3832,55.4835 51.0499,57.1502 52.5,58.5C 51.4798,60.4325 51.3131,62.4325 52,64.5C 52.8355,67.5517 54.3355,69.385 56.5,70C 54.8588,71.0219 53.3588,72.5219 52,74.5C 51.3076,73.9747 50.8076,73.3081 50.5,72.5C 51.2458,71.2638 51.5792,69.9305 51.5,68.5C 49.4588,68.8541 47.6255,68.8541 46,68.5C 43.6023,68.9582 41.9356,70.2915 41,72.5C 40.1627,70.9926 38.9961,70.4926 37.5,71C 38.3521,73.4168 39.0188,75.9168 39.5,78.5C 39.0814,79.6721 38.4147,80.6721 37.5,81.5C 38.0253,82.1924 38.6919,82.6924 39.5,83C 37.8659,83.4935 36.1992,83.6602 34.5,83.5C 34.3921,81.2166 33.5588,79.2166 32,77.5C 30.1316,78.6719 28.2983,78.5053 26.5,77C 27.6492,75.2559 28.9825,75.0892 30.5,76.5C 31.5,76.1667 32.1667,75.5 32.5,74.5C 30.5654,73.9322 29.2321,72.7655 28.5,71C 29.0682,69.1284 29.7349,67.2951 30.5,65.5C 29.1756,64.3131 28.1756,64.6465 27.5,66.5C 27.7093,67.086 28.0426,67.586 28.5,68C 26.1865,71.1269 24.8532,74.6269 24.5,78.5C 22.8008,78.3398 21.1341,78.5065 19.5,79C 20,79.5 20.5,80 21,80.5C 22.3561,79.6198 23.8561,79.2865 25.5,79.5C 25.7286,81.433 26.5619,83.0997 28,84.5C 28.6667,83.8333 29.3333,83.1667 30,82.5C 30,83.8333 30,85.1667 30,86.5C 33.0372,88.0267 35.5372,90.1934 37.5,93C 38.5,93.6667 39.5,93.6667 40.5,93C 40.1667,92.6667 39.8333,92.3333 39.5,92C 40.1905,90.9326 40.6905,89.7659 41,88.5C 41.5847,90.6614 42.4181,92.6614 43.5,94.5C 31.7715,94.0476 20.4382,92.7143 9.5,90.5C 8.77974,84.7436 8.4464,78.7436 8.5,72.5C 9.15149,71.9094 9.81815,71.2427 10.5,70.5C 11.8333,70.8333 13.1667,71.1667 14.5,71.5C 16.8372,64.1265 20.5039,63.1265 25.5,68.5C 26.9424,63.5287 25.6091,59.362 21.5,56C 22.0897,54.4905 22.7564,52.9905 23.5,51.5C 24.086,51.7093 24.586,52.0426 25,52.5C 25.4966,54.8098 25.6633,57.1432 25.5,59.5C 27.604,59.7989 29.604,59.4656 31.5,58.5C 29.8598,58.8475 28.1932,58.3475 26.5,57C 27.91,56.6322 28.91,55.7989 29.5,54.5C 28.7261,53.2888 27.8928,53.2888 27,54.5C 26.3448,52.3716 25.5114,50.3716 24.5,48.5C 27.1817,45.6397 26.5151,44.8064 22.5,46C 23.8333,45.3333 23.8333,44.6667 22.5,44C 25.8508,43.7167 28.8508,42.5501 31.5,40.5C 30.9344,39.7087 30.101,39.7087 29,40.5C 23.2926,39.2922 22.4593,36.7922 26.5,33C 25.2845,30.9045 24.4512,31.0712 24,33.5C 23.3333,32.1667 22.6667,32.1667 22,33.5C 21.6667,32.1667 21.3333,30.8333 21,29.5C 20.5488,31.9288 19.7155,32.0955 18.5,30C 19.6226,28.9563 20.9559,28.2896 22.5,28C 20.8353,27.2115 19.1686,26.8782 17.5,27C 17.8333,27.3333 18.1667,27.6667 18.5,28C 17.3636,29.1451 16.3636,30.3117 15.5,31.5C 15.7778,29.6536 15.1112,28.3202 13.5,27.5C 13.4827,28.3937 13.1494,29.3937 12.5,30.5C 11.5655,29.4324 11.2322,28.099 11.5,26.5C 11.7208,23.9028 12.2208,23.9028 13,26.5C 13.6667,24.8333 13.6667,23.1667 13,21.5C 12.3333,20.1667 11.6667,20.1667 11,21.5C 10.3551,20.354 9.52173,19.354 8.5,18.5C 9.16667,18.1667 9.83333,17.8333 10.5,17.5C 25.6095,22.2056 40.6095,26.8723 55.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebcabe",
    d: "M 15.5,31.5 C 12.956,36.5761 11.956,36.2428 12.5,30.5C 13.1494,29.3937 13.4827,28.3937 13.5,27.5C 15.1112,28.3202 15.7778,29.6536 15.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eccdbf",
    d: "M 18.5,44.5 C 17.448,44.3505 16.448,44.5172 15.5,45C 16.5541,47.3822 17.2208,49.8822 17.5,52.5C 13.6334,51.9608 12.9668,50.4608 15.5,48C 15,47.5 14.5,47 14,46.5C 13.1049,49.7671 11.2716,50.4338 8.5,48.5C 8.5,48.1667 8.5,47.8333 8.5,47.5C 9.15149,46.9094 9.81815,46.2427 10.5,45.5C 12.2141,46.6085 12.8808,45.9418 12.5,43.5C 11.5,43.5 10.5,43.5 9.5,43.5C 9.5,42.8333 9.5,42.1667 9.5,41.5C 11.0968,40.2627 12.2635,38.596 13,36.5C 12.4644,38.447 12.7978,40.447 14,42.5C 14.3333,41.8333 14.6667,41.1667 15,40.5C 15.6259,42.9913 16.4593,42.9913 17.5,40.5C 18.4287,41.6888 18.762,43.0222 18.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c54d5d",
    d: "M 9.5,43.5 C 10.5,43.5 11.5,43.5 12.5,43.5C 12.8808,45.9418 12.2141,46.6085 10.5,45.5C 9.81815,46.2427 9.15149,46.9094 8.5,47.5C 8.23219,45.901 8.56552,44.5676 9.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#de9599",
    d: "M 28.5,45.5 C 29.5,45.5 30.5,45.5 31.5,45.5C 31.5,46.8333 31.5,48.1667 31.5,49.5C 30.1667,49.5 28.8333,49.5 27.5,49.5C 27.4326,48.0413 27.7659,46.7079 28.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#39bdb2",
    d: "M 370.5,48.5 C 373.518,48.3354 376.518,48.502 379.5,49C 380.167,50.6667 380.833,52.3333 381.5,54C 377.848,54.4986 374.182,54.6653 370.5,54.5C 370.5,52.5 370.5,50.5 370.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#524435",
    d: "M 382.5,47.5 C 385.286,49.1126 387.953,50.946 390.5,53C 385.208,54.599 382.541,52.7657 382.5,47.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#47c2b8",
    d: "M 464.5,41.5 C 464.308,44.8091 465.641,47.3091 468.5,49C 468.167,49.3333 467.833,49.6667 467.5,50C 468.525,52.0715 469.358,54.2381 470,56.5C 472.667,55.8333 475.333,55.1667 478,54.5C 480.26,56.9972 481.593,56.3305 482,52.5C 482.667,53.8333 483.333,53.8333 484,52.5C 484.692,53.0253 485.192,53.6919 485.5,54.5C 485.196,57.0456 485.196,59.3789 485.5,61.5C 483.235,63.642 480.568,65.3087 477.5,66.5C 472.276,69.7798 466.276,72.7798 459.5,75.5C 457.898,74.45 457.065,75.1167 457,77.5C 443.493,84.2682 429.493,91.6015 415,99.5C 414.79,97.9419 414.29,96.6085 413.5,95.5C 413.5,94.8333 413.167,94.5 412.5,94.5C 408.953,92.3058 407.953,89.3058 409.5,85.5C 427.985,71.082 446.319,56.4154 464.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2ebcb4",
    d: "M 321.5,44.5 C 328.339,56.176 334.673,68.176 340.5,80.5C 340.693,84.5662 340.36,88.5662 339.5,92.5C 338.033,93.2916 336.7,93.2916 335.5,92.5C 326.453,81.1289 317.453,69.7956 308.5,58.5C 310.288,58.7852 311.955,58.4519 313.5,57.5C 316.429,53.306 319.095,48.9726 321.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d78385",
    d: "M 17.5,52.5 C 18.2216,52.0825 18.7216,51.4158 19,50.5C 19.0343,52.1796 19.201,53.6796 19.5,55C 17.5571,58.3324 16.3905,58.1658 16,54.5C 15.5357,55.0944 15.369,55.7611 15.5,56.5C 13.321,56.16 11.4877,55.16 10,53.5C 9.66667,54.1667 9.33333,54.8333 9,55.5C 8.50335,53.1902 8.33669,50.8568 8.5,48.5C 11.2716,50.4338 13.1049,49.7671 14,46.5C 14.5,47 15,47.5 15.5,48C 12.9668,50.4608 13.6334,51.9608 17.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eef0d7",
    d: "M 358.5,56.5 C 353.125,56.1718 347.792,56.5052 342.5,57.5C 344.186,62.5912 346.019,67.5912 348,72.5C 348.754,69.3156 350.254,66.6489 352.5,64.5C 350.119,68.4862 349.119,72.8195 349.5,77.5C 348.732,76.7375 348.232,75.7375 348,74.5C 347.667,79.8333 347.333,85.1667 347,90.5C 346.667,87.5 346.333,84.5 346,81.5C 344.644,80.6198 343.144,80.2865 341.5,80.5C 341.167,80.5 340.833,80.5 340.5,80.5C 334.673,68.176 328.339,56.176 321.5,44.5C 322.301,42.9582 322.634,41.2915 322.5,39.5C 325.463,38.5371 327.463,36.5371 328.5,33.5C 329.497,40.8032 329.831,48.1365 329.5,55.5C 339.348,55.1729 349.014,55.5062 358.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#33bdb4",
    d: "M 358.5,56.5 C 358.443,57.609 358.11,58.609 357.5,59.5C 354.833,60.1667 353.167,61.8333 352.5,64.5C 350.254,66.6489 348.754,69.3156 348,72.5C 346.019,67.5912 344.186,62.5912 342.5,57.5C 347.792,56.5052 353.125,56.1718 358.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b8d9e",
    d: "M 368.5,55.5 C 368.179,60.6946 368.513,65.6946 369.5,70.5C 370.5,71.8333 371.5,71.8333 372.5,70.5C 373.487,65.6946 373.821,60.6946 373.5,55.5C 378.1,55.2796 382.433,55.9462 386.5,57.5C 385.514,61.97 385.181,66.6367 385.5,71.5C 386.822,71.67 387.989,71.3366 389,70.5C 389.499,66.5138 389.666,62.5138 389.5,58.5C 396.909,62.5947 400.575,68.928 400.5,77.5C 399.833,77.5 399.167,77.5 398.5,77.5C 382.833,77.5 367.167,77.5 351.5,77.5C 350.833,77.5 350.167,77.5 349.5,77.5C 349.119,72.8195 350.119,68.4862 352.5,64.5C 354.5,63.1667 356.167,61.5 357.5,59.5C 358.833,59.1667 360.167,58.8333 361.5,58.5C 361.5,62.8333 361.5,67.1667 361.5,71.5C 362.822,71.67 363.989,71.3366 365,70.5C 365.499,65.8452 365.666,61.1785 365.5,56.5C 366.209,55.596 367.209,55.2627 368.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00284f",
    d: "M 372.5,70.5 C 371.5,71.8333 370.5,71.8333 369.5,70.5C 369.5,65.8333 369.5,61.1667 369.5,56.5C 370.5,56.5 371.5,56.5 372.5,56.5C 372.5,61.1667 372.5,65.8333 372.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00284f",
    d: "M 377.5,56.5 C 378.5,56.5 379.5,56.5 380.5,56.5C 380.5,61.5 380.5,66.5 380.5,71.5C 379.5,71.5 378.5,71.5 377.5,71.5C 377.5,66.5 377.5,61.5 377.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb2f46",
    d: "M 55.5,31.5 C 150.49,60.163 245.49,88.8296 340.5,117.5C 340.5,119.833 340.5,122.167 340.5,124.5C 267.431,117.752 194.431,110.418 121.5,102.5C 121.509,100.692 121.009,99.0249 120,97.5C 119.51,98.7932 119.343,100.127 119.5,101.5C 117.167,101.5 114.833,101.5 112.5,101.5C 91.8236,99.4977 71.157,97.4977 50.5,95.5C 50.3894,93.3523 51.056,93.019 52.5,94.5C 53.5,94.1667 54.1667,93.5 54.5,92.5C 52.5832,91.1665 51.5832,89.3331 51.5,87C 52.1557,85.0909 52.6557,83.2576 53,81.5C 50.9916,82.7636 49.8249,84.5969 49.5,87C 51.2161,90.315 50.5495,92.815 47.5,94.5C 46.1667,94.5 44.8333,94.5 43.5,94.5C 42.4181,92.6614 41.5847,90.6614 41,88.5C 40.6905,89.7659 40.1905,90.9326 39.5,92C 39.8333,92.3333 40.1667,92.6667 40.5,93C 39.5,93.6667 38.5,93.6667 37.5,93C 35.5372,90.1934 33.0372,88.0267 30,86.5C 30,85.1667 30,83.8333 30,82.5C 29.3333,83.1667 28.6667,83.8333 28,84.5C 26.5619,83.0997 25.7286,81.433 25.5,79.5C 23.8561,79.2865 22.3561,79.6198 21,80.5C 20.5,80 20,79.5 19.5,79C 21.1341,78.5065 22.8008,78.3398 24.5,78.5C 24.8532,74.6269 26.1865,71.1269 28.5,68C 28.0426,67.586 27.7093,67.086 27.5,66.5C 28.1756,64.6465 29.1756,64.3131 30.5,65.5C 29.7349,67.2951 29.0682,69.1284 28.5,71C 29.2321,72.7655 30.5654,73.9322 32.5,74.5C 32.1667,75.5 31.5,76.1667 30.5,76.5C 28.9825,75.0892 27.6492,75.2559 26.5,77C 28.2983,78.5053 30.1316,78.6719 32,77.5C 33.5588,79.2166 34.3921,81.2166 34.5,83.5C 36.1992,83.6602 37.8659,83.4935 39.5,83C 38.6919,82.6924 38.0253,82.1924 37.5,81.5C 38.4147,80.6721 39.0814,79.6721 39.5,78.5C 39.0188,75.9168 38.3521,73.4168 37.5,71C 38.9961,70.4926 40.1627,70.9926 41,72.5C 41.9356,70.2915 43.6023,68.9582 46,68.5C 47.6255,68.8541 49.4588,68.8541 51.5,68.5C 51.5792,69.9305 51.2458,71.2638 50.5,72.5C 50.8076,73.3081 51.3076,73.9747 52,74.5C 53.3588,72.5219 54.8588,71.0219 56.5,70C 54.3355,69.385 52.8355,67.5517 52,64.5C 51.3131,62.4325 51.4798,60.4325 52.5,58.5C 51.0499,57.1502 50.3832,55.4835 50.5,53.5C 51.675,53.719 52.675,53.3857 53.5,52.5C 52.1667,52.1667 50.8333,51.8333 49.5,51.5C 50,50.5 50.5,49.5 51,48.5C 51.3333,48.8333 51.6667,49.1667 52,49.5C 53.7137,47.9568 55.2137,46.2901 56.5,44.5C 55.5,42.8333 54.5,41.1667 53.5,39.5C 54.325,38.6143 55.325,38.281 56.5,38.5C 56.3259,36.139 55.9926,33.8056 55.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#033055",
    d: "M 365.5,56.5 C 365.666,61.1785 365.499,65.8452 365,70.5C 363.989,71.3366 362.822,71.67 361.5,71.5C 361.5,67.1667 361.5,62.8333 361.5,58.5C 362.514,57.3263 363.847,56.6596 365.5,56.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#033055",
    d: "M 386.5,57.5 C 387.609,57.5569 388.609,57.8902 389.5,58.5C 389.666,62.5138 389.499,66.5138 389,70.5C 387.989,71.3366 386.822,71.67 385.5,71.5C 385.181,66.6367 385.514,61.97 386.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#41c0b8",
    d: "M 423.5,53.5 C 417.552,62.3897 410.885,70.723 403.5,78.5C 402.488,72.951 400.488,67.7843 397.5,63C 398.609,60.9534 399.276,58.7867 399.5,56.5C 406.408,56.5853 413.075,55.4186 419.5,53C 422.3,48.5616 423.633,48.7283 423.5,53.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cb5f6a",
    d: "M 18.5,44.5 C 18.9371,46.0744 19.9371,47.2411 21.5,48C 20.5,48.3333 19.5,48.6667 18.5,49C 20.5045,50.5903 22.5045,50.4236 24.5,48.5C 25.5114,50.3716 26.3448,52.3716 27,54.5C 27.8928,53.2888 28.7261,53.2888 29.5,54.5C 28.91,55.7989 27.91,56.6322 26.5,57C 28.1932,58.3475 29.8598,58.8475 31.5,58.5C 29.604,59.4656 27.604,59.7989 25.5,59.5C 25.6633,57.1432 25.4966,54.8098 25,52.5C 24.586,52.0426 24.086,51.7093 23.5,51.5C 22.7564,52.9905 22.0897,54.4905 21.5,56C 25.6091,59.362 26.9424,63.5287 25.5,68.5C 20.5039,63.1265 16.8372,64.1265 14.5,71.5C 13.1667,71.1667 11.8333,70.8333 10.5,70.5C 9.81815,71.2427 9.15149,71.9094 8.5,72.5C 9.36478,67.7335 9.36478,63.0668 8.5,58.5C 10.7522,57.6669 12.9189,57.6669 15,58.5C 15.4643,57.9056 15.631,57.2389 15.5,56.5C 15.369,55.7611 15.5357,55.0944 16,54.5C 16.3905,58.1658 17.5571,58.3324 19.5,55C 19.201,53.6796 19.0343,52.1796 19,50.5C 18.7216,51.4158 18.2216,52.0825 17.5,52.5C 17.2208,49.8822 16.5541,47.3822 15.5,45C 16.448,44.5172 17.448,44.3505 18.5,44.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4b3ab",
    d: "M 12.5,61.5 C 14.5167,60.126 16.5167,60.2926 18.5,62C 16.4546,62.4901 14.4546,62.3235 12.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cfcf9b",
    d: "M 357.5,59.5 C 356.167,61.5 354.5,63.1667 352.5,64.5C 353.167,61.8333 354.833,60.1667 357.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#125572",
    d: "M 368.5,55.5 C 370.167,55.5 371.833,55.5 373.5,55.5C 373.821,60.6946 373.487,65.6946 372.5,70.5C 372.5,65.8333 372.5,61.1667 372.5,56.5C 371.5,56.5 370.5,56.5 369.5,56.5C 369.5,61.1667 369.5,65.8333 369.5,70.5C 368.513,65.6946 368.179,60.6946 368.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c64d5f",
    d: "M 73.5,55.5 C 76.1087,59.0716 78.7754,62.7383 81.5,66.5C 82.8544,64.8164 84.5211,64.3164 86.5,65C 84.968,65.6995 83.968,66.8662 83.5,68.5C 84.8114,69.2575 85.3114,70.2575 85,71.5C 83.7727,73.7261 81.9393,75.2261 79.5,76C 80.7112,76.8928 80.7112,77.7261 79.5,78.5C 76.5905,73.9347 73.5905,69.4347 70.5,65C 70.6667,64.5 70.8333,64 71,63.5C 72,64.8333 73,66.1667 74,67.5C 74.8333,66 76,64.8333 77.5,64C 74.1558,62.106 72.8224,59.2727 73.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc4948",
    d: "M 349.5,77.5 C 350.167,77.5 350.833,77.5 351.5,77.5C 351.5,78.5 351.5,79.5 351.5,80.5C 350.833,80.5 350.167,80.5 349.5,80.5C 349.5,79.5 349.5,78.5 349.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ead599",
    d: "M 351.5,77.5 C 367.167,77.5 382.833,77.5 398.5,77.5C 398.5,78.5 398.5,79.5 398.5,80.5C 382.833,80.5 367.167,80.5 351.5,80.5C 351.5,79.5 351.5,78.5 351.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fa3d42",
    d: "M 398.5,77.5 C 399.167,77.5 399.833,77.5 400.5,77.5C 400.5,78.5 400.5,79.5 400.5,80.5C 399.833,80.5 399.167,80.5 398.5,80.5C 398.5,79.5 398.5,78.5 398.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3c94a0",
    d: "M 349.5,80.5 C 350.167,80.5 350.833,80.5 351.5,80.5C 367.167,80.5 382.833,80.5 398.5,80.5C 399.167,80.5 399.833,80.5 400.5,80.5C 400.833,80.5 401.167,80.5 401.5,80.5C 401.784,82.4147 401.451,84.0813 400.5,85.5C 399.833,85.5 399.167,85.5 398.5,85.5C 382.833,85.5 367.167,85.5 351.5,85.5C 351.158,84.6618 350.492,84.3284 349.5,84.5C 348.167,83.1667 348.167,81.8333 349.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#288d9f",
    d: "M 344.5,91.5 C 343.833,91.5 343.167,91.5 342.5,91.5C 342.5,88.5 342.5,85.5 342.5,82.5C 342.56,81.9569 342.893,81.6236 343.5,81.5C 344.487,84.7683 344.82,88.1016 344.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d36f7e",
    d: "M 122.5,78.5 C 123.622,80.2884 123.789,82.2884 123,84.5C 121.115,89.0462 118.448,93.0462 115,96.5C 114.405,95.1011 114.572,93.7678 115.5,92.5C 117.739,89.3456 120.073,86.179 122.5,83C 121.272,81.5098 121.272,80.0098 122.5,78.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e65754",
    d: "M 349.5,84.5 C 350.492,84.3284 351.158,84.6618 351.5,85.5C 351.5,86.5 351.5,87.5 351.5,88.5C 350.833,88.5 350.167,88.5 349.5,88.5C 349.5,87.1667 349.5,85.8333 349.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9d599",
    d: "M 351.5,85.5 C 367.167,85.5 382.833,85.5 398.5,85.5C 398.5,86.5 398.5,87.5 398.5,88.5C 382.833,88.5 367.167,88.5 351.5,88.5C 351.5,87.5 351.5,86.5 351.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd363d",
    d: "M 398.5,85.5 C 399.167,85.5 399.833,85.5 400.5,85.5C 400.5,86.5 400.5,87.5 400.5,88.5C 399.833,88.5 399.167,88.5 398.5,88.5C 398.5,87.5 398.5,86.5 398.5,85.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfcc99",
    d: "M 349.5,77.5 C 349.5,78.5 349.5,79.5 349.5,80.5C 348.167,81.8333 348.167,83.1667 349.5,84.5C 349.5,85.8333 349.5,87.1667 349.5,88.5C 348.167,89.8333 348.167,91.1667 349.5,92.5C 349.5,93.8333 349.5,95.1667 349.5,96.5C 348.292,97.2341 346.959,97.5674 345.5,97.5C 345.795,95.2646 345.461,93.2646 344.5,91.5C 344.82,88.1016 344.487,84.7683 343.5,81.5C 342.893,81.6236 342.56,81.9569 342.5,82.5C 341.662,82.1583 341.328,81.4916 341.5,80.5C 343.144,80.2865 344.644,80.6198 346,81.5C 346.333,84.5 346.667,87.5 347,90.5C 347.333,85.1667 347.667,79.8333 348,74.5C 348.232,75.7375 348.732,76.7375 349.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3893a1",
    d: "M 349.5,88.5 C 350.167,88.5 350.833,88.5 351.5,88.5C 367.167,88.5 382.833,88.5 398.5,88.5C 399.167,88.5 399.833,88.5 400.5,88.5C 400.5,90.1667 400.5,91.8333 400.5,93.5C 399.833,93.5 399.167,93.5 398.5,93.5C 382.833,93.5 367.167,93.5 351.5,93.5C 351.158,92.6618 350.492,92.3284 349.5,92.5C 348.167,91.1667 348.167,89.8333 349.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7ce9d",
    d: "M 401.5,80.5 C 402.766,82.6943 402.766,85.0276 401.5,87.5C 402,88.5 402.5,89.5 403,90.5C 403.256,87.443 403.756,84.443 404.5,81.5C 407.787,80.4317 409.454,81.7651 409.5,85.5C 407.953,89.3058 408.953,92.3058 412.5,94.5C 410.5,94.5 409.5,95.5 409.5,97.5C 408.833,95.5 408.167,93.5 407.5,91.5C 406.833,79.5 406.167,79.5 405.5,91.5C 403.692,92.9179 403.025,94.9179 403.5,97.5C 402.209,97.7373 401.209,97.404 400.5,96.5C 400.5,95.5 400.5,94.5 400.5,93.5C 400.5,91.8333 400.5,90.1667 400.5,88.5C 400.5,87.5 400.5,86.5 400.5,85.5C 401.451,84.0813 401.784,82.4147 401.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#238ea1",
    d: "M 407.5,91.5 C 406.833,91.5 406.167,91.5 405.5,91.5C 406.167,79.5 406.833,79.5 407.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#00274f",
    d: "M 342.5,91.5 C 343.167,91.5 343.833,91.5 344.5,91.5C 345.461,93.2646 345.795,95.2646 345.5,97.5C 345.5,98.5 345.5,99.5 345.5,100.5C 345.5,102.167 345.5,103.833 345.5,105.5C 344.167,105.5 342.833,105.5 341.5,105.5C 341.181,100.637 341.514,95.97 342.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#153556",
    d: "M 405.5,91.5 C 406.167,91.5 406.833,91.5 407.5,91.5C 408.167,93.5 408.833,95.5 409.5,97.5C 409.5,98.5 409.5,99.5 409.5,100.5C 408.833,102.5 408.167,104.5 407.5,106.5C 406.833,106.5 406.167,106.5 405.5,106.5C 403.692,105.082 403.025,103.082 403.5,100.5C 403.5,99.5 403.5,98.5 403.5,97.5C 403.025,94.9179 403.692,92.9179 405.5,91.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d16c7a",
    d: "M 50.5,95.5 C 49.209,95.7373 48.209,95.404 47.5,94.5C 50.5495,92.815 51.2161,90.315 49.5,87C 49.8249,84.5969 50.9916,82.7636 53,81.5C 52.6557,83.2576 52.1557,85.0909 51.5,87C 51.5832,89.3331 52.5832,91.1665 54.5,92.5C 54.1667,93.5 53.5,94.1667 52.5,94.5C 51.056,93.019 50.3894,93.3523 50.5,95.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e45c56",
    d: "M 349.5,92.5 C 350.492,92.3284 351.158,92.6618 351.5,93.5C 351.5,94.5 351.5,95.5 351.5,96.5C 350.833,96.5 350.167,96.5 349.5,96.5C 349.5,95.1667 349.5,93.8333 349.5,92.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8d498",
    d: "M 351.5,93.5 C 367.167,93.5 382.833,93.5 398.5,93.5C 398.5,94.5 398.5,95.5 398.5,96.5C 382.833,96.5 367.167,96.5 351.5,96.5C 351.5,95.5 351.5,94.5 351.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd4645",
    d: "M 398.5,93.5 C 399.167,93.5 399.833,93.5 400.5,93.5C 400.5,94.5 400.5,95.5 400.5,96.5C 399.833,96.5 399.167,96.5 398.5,96.5C 398.5,95.5 398.5,94.5 398.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f74e49",
    d: "M 340.5,94.5 C 340.664,97.1873 340.497,99.854 340,102.5C 338.855,103.684 337.688,103.684 336.5,102.5C 336.337,100.143 336.503,97.8098 337,95.5C 338.011,94.6634 339.178,94.33 340.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd373d",
    d: "M 412.5,94.5 C 412.5,97.5 412.5,100.5 412.5,103.5C 411.5,103.5 410.5,103.5 409.5,103.5C 409.5,102.5 409.5,101.5 409.5,100.5C 409.5,99.5 409.5,98.5 409.5,97.5C 409.5,95.5 410.5,94.5 412.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dc8a97",
    d: "M 169.5,93.5 C 169.56,92.9569 169.893,92.6236 170.5,92.5C 171.357,93.7357 172.023,95.069 172.5,96.5C 171.316,98.0461 170.316,99.7127 169.5,101.5C 167.15,100.226 167.317,98.8927 170,97.5C 170.765,95.9343 170.598,94.6009 169.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b93a0",
    d: "M 349.5,96.5 C 350.167,96.5 350.833,96.5 351.5,96.5C 367.167,96.5 382.833,96.5 398.5,96.5C 399.167,96.5 399.833,96.5 400.5,96.5C 401.209,97.404 402.209,97.7373 403.5,97.5C 403.5,98.5 403.5,99.5 403.5,100.5C 402.209,100.263 401.209,100.596 400.5,101.5C 399.833,101.5 399.167,101.5 398.5,101.5C 382.833,101.5 367.167,101.5 351.5,101.5C 350.833,101.5 350.167,101.5 349.5,101.5C 348.432,100.566 347.099,100.232 345.5,100.5C 345.5,99.5 345.5,98.5 345.5,97.5C 346.959,97.5674 348.292,97.2341 349.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8828b",
    d: "M 121.5,102.5 C 118.287,102.81 115.287,102.477 112.5,101.5C 114.833,101.5 117.167,101.5 119.5,101.5C 119.343,100.127 119.51,98.7932 120,97.5C 121.009,99.0249 121.509,100.692 121.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#44949f",
    d: "M 405.5,106.5 C 406.167,106.5 406.833,106.5 407.5,106.5C 407.175,114.352 407.508,122.018 408.5,129.5C 413.049,129.624 417.382,130.291 421.5,131.5C 416.797,131.563 412.13,131.229 407.5,130.5C 405.935,132.509 404.935,134.843 404.5,137.5C 402.529,139.808 400.529,142.142 398.5,144.5C 393.738,146.838 389.071,149.171 384.5,151.5C 384.5,149.5 384.5,147.5 384.5,145.5C 391.299,146.021 396.799,143.354 401,137.5C 403.184,134.134 404.517,130.467 405,126.5C 405.5,119.842 405.666,113.175 405.5,106.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a1b898",
    d: "M 340.5,80.5 C 340.833,80.5 341.167,80.5 341.5,80.5C 341.328,81.4916 341.662,82.1583 342.5,82.5C 342.5,85.5 342.5,88.5 342.5,91.5C 341.514,95.97 341.181,100.637 341.5,105.5C 342.466,113.08 342.799,120.747 342.5,128.5C 342.167,128.5 341.833,128.5 341.5,128.5C 341.5,128.167 341.5,127.833 341.5,127.5C 341.818,122.968 341.485,118.634 340.5,114.5C 340.664,111.813 340.497,109.146 340,106.5C 338.612,105.264 337.446,103.931 336.5,102.5C 337.688,103.684 338.855,103.684 340,102.5C 340.497,99.854 340.664,97.1873 340.5,94.5C 340.672,93.5084 340.338,92.8417 339.5,92.5C 340.36,88.5662 340.693,84.5662 340.5,80.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eed197",
    d: "M 412.5,94.5 C 413.167,94.5 413.5,94.8333 413.5,95.5C 413.38,97.7345 413.713,99.9011 414.5,102C 413.623,103.867 412.123,105.034 410,105.5C 408.872,107.345 408.372,109.345 408.5,111.5C 408.5,115.167 408.5,118.833 408.5,122.5C 408.5,124.833 408.5,127.167 408.5,129.5C 407.508,122.018 407.175,114.352 407.5,106.5C 408.167,104.5 408.833,102.5 409.5,100.5C 409.5,101.5 409.5,102.5 409.5,103.5C 410.5,103.5 411.5,103.5 412.5,103.5C 412.5,100.5 412.5,97.5 412.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb2f45",
    d: "M 341.5,127.5 C 341.5,127.833 341.5,128.167 341.5,128.5C 341.286,130.144 341.62,131.644 342.5,133C 276.019,153.032 209.685,173.198 143.5,193.5C 98.5,193.5 53.5,193.5 8.5,193.5C 8.5,184.833 8.5,176.167 8.5,167.5C 9.31491,166.571 10.1482,165.571 11,164.5C 11.7175,165.451 12.5509,165.617 13.5,165C 13.9302,164.08 14.2635,163.247 14.5,162.5C 15.2811,163.729 15.7811,165.062 16,166.5C 17.0084,166.018 18.175,165.852 19.5,166C 18.7433,164.488 17.7433,163.154 16.5,162C 17.5634,160.812 18.8967,160.312 20.5,160.5C 20.2148,162.288 20.5481,163.955 21.5,165.5C 22.2309,163.599 22.2309,161.599 21.5,159.5C 128.107,148.173 234.774,137.507 341.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb2e45",
    d: "M 407.5,130.5 C 412.13,131.229 416.797,131.563 421.5,131.5C 522.967,140.68 624.3,150.847 725.5,162C 724.289,162.893 724.289,163.726 725.5,164.5C 726.107,164.376 726.44,164.043 726.5,163.5C 727.653,164.313 727.653,165.313 726.5,166.5C 725.335,167.584 724.002,168.417 722.5,169C 723.833,169.667 724.833,170.667 725.5,172C 723.606,173.101 722.939,174.434 723.5,176C 726.422,176.417 729.089,177.417 731.5,179C 731,179.5 730.5,180 730,180.5C 727.62,177.071 725.12,176.905 722.5,180C 725.742,180.283 726.076,181.117 723.5,182.5C 724.025,183.192 724.692,183.692 725.5,184C 724.207,184.49 722.873,184.657 721.5,184.5C 721.354,186.942 722.187,187.609 724,186.5C 725.154,187.743 726.488,188.743 728,189.5C 728.667,186.833 729.333,186.833 730,189.5C 730.483,188.552 730.649,187.552 730.5,186.5C 735.099,185.013 735.765,186.346 732.5,190.5C 731.099,191.521 729.765,192.521 728.5,193.5C 679.5,193.5 630.5,193.5 581.5,193.5C 522.87,175.116 464.536,157.283 406.5,140C 405.244,139.583 404.577,138.75 404.5,137.5C 406.448,135.68 407.448,133.346 407.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc693",
    d: "M 407.5,130.5 C 407.448,133.346 406.448,135.68 404.5,137.5C 404.935,134.843 405.935,132.509 407.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1d8",
    d: "M 341.5,128.5 C 341.833,128.5 342.167,128.5 342.5,128.5C 343.192,131.936 344.192,135.27 345.5,138.5C 344.518,137.859 343.518,137.193 342.5,136.5C 306.787,155.02 271.453,174.02 236.5,193.5C 205.5,193.5 174.5,193.5 143.5,193.5C 209.685,173.198 276.019,153.032 342.5,133C 341.62,131.644 341.286,130.144 341.5,128.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c03e4e",
    d: "M 353.5,136.5 C 352.292,137.234 350.959,137.567 349.5,137.5C 349.573,135.973 348.906,134.973 347.5,134.5C 350.4,131.687 352.4,132.353 353.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb2f45",
    d: "M 345.5,138.5 C 346.292,139.967 346.292,141.3 345.5,142.5C 324.789,159.553 304.123,176.553 283.5,193.5C 267.833,193.5 252.167,193.5 236.5,193.5C 271.453,174.02 306.787,155.02 342.5,136.5C 343.518,137.193 344.518,137.859 345.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dcc69e",
    d: "M 353.5,136.5 C 353.461,137.583 353.127,138.583 352.5,139.5C 353.193,140.518 353.859,141.518 354.5,142.5C 351.833,141.833 350.167,140.167 349.5,137.5C 350.959,137.567 352.292,137.234 353.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dbc99e",
    d: "M 345.5,100.5 C 347.099,100.232 348.432,100.566 349.5,101.5C 348.102,102.777 347.436,104.443 347.5,106.5C 347.84,108.512 348.173,110.512 348.5,112.5C 348.232,114.099 348.566,115.432 349.5,116.5C 349.5,117.833 349.5,119.167 349.5,120.5C 348.903,120.735 348.57,121.235 348.5,122C 349.479,124.433 350.145,126.933 350.5,129.5C 353.185,133.183 356.518,136.183 360.5,138.5C 360.842,139.338 361.508,139.672 362.5,139.5C 364.214,140.738 366.214,141.405 368.5,141.5C 369.833,141.5 371.167,141.5 372.5,141.5C 373.833,141.5 375.167,141.5 376.5,141.5C 377.833,141.5 379.167,141.5 380.5,141.5C 381.959,141.567 383.292,141.234 384.5,140.5C 385.995,140.011 387.329,139.345 388.5,138.5C 390.969,137.431 393.302,136.098 395.5,134.5C 398.279,130.267 399.945,125.6 400.5,120.5C 400.5,119.5 400.5,118.5 400.5,117.5C 400.5,115.833 400.5,114.167 400.5,112.5C 400.5,111.5 400.5,110.5 400.5,109.5C 400.5,107.833 400.5,106.167 400.5,104.5C 400.5,103.5 400.5,102.5 400.5,101.5C 401.209,100.596 402.209,100.263 403.5,100.5C 403.025,103.082 403.692,105.082 405.5,106.5C 405.666,113.175 405.5,119.842 405,126.5C 404.517,130.467 403.184,134.134 401,137.5C 396.799,143.354 391.299,146.021 384.5,145.5C 378.021,144.509 371.354,144.176 364.5,144.5C 364.167,144.5 363.833,144.5 363.5,144.5C 363.53,145.497 363.03,146.164 362,146.5C 358.952,145.999 356.452,144.666 354.5,142.5C 356.252,142.582 357.252,141.749 357.5,140C 356.928,137.926 355.595,136.76 353.5,136.5C 352.4,132.353 350.4,131.687 347.5,134.5C 346.207,133.158 345.374,131.491 345,129.5C 344.2,121.421 344.367,113.421 345.5,105.5C 345.5,103.833 345.5,102.167 345.5,100.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf394b",
    d: "M 395.5,134.5 C 397.168,133.156 398.835,131.823 400.5,130.5C 401.167,130.833 401.833,131.167 402.5,131.5C 401.649,133.882 400.316,135.882 398.5,137.5C 396.787,137.121 395.787,136.121 395.5,134.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#032e53",
    d: "M 388.5,138.5 C 387.329,139.345 385.995,140.011 384.5,140.5C 384.2,135.901 384.533,131.401 385.5,127C 386.449,126.383 387.282,126.549 388,127.5C 388.499,131.152 388.665,134.818 388.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#032d53",
    d: "M 362.5,139.5 C 361.508,139.672 360.842,139.338 360.5,138.5C 360.335,134.818 360.501,131.152 361,127.5C 362,126.167 363,126.167 364,127.5C 364.167,129.5 364.333,131.5 364.5,133.5C 364.461,135.952 363.794,137.952 362.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c03e4c",
    d: "M 350.5,129.5 C 349.817,131.176 348.483,131.843 346.5,131.5C 346.215,129.712 346.548,128.045 347.5,126.5C 348.288,127.77 349.288,128.77 350.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#298ea0",
    d: "M 349.5,120.5 C 350.167,120.5 350.833,120.5 351.5,120.5C 367.167,120.5 382.833,120.5 398.5,120.5C 399.167,120.5 399.833,120.5 400.5,120.5C 399.945,125.6 398.279,130.267 395.5,134.5C 393.302,136.098 390.969,137.431 388.5,138.5C 388.665,134.818 388.499,131.152 388,127.5C 387.282,126.549 386.449,126.383 385.5,127C 384.533,131.401 384.2,135.901 384.5,140.5C 383.292,141.234 381.959,141.567 380.5,141.5C 380.666,136.821 380.499,132.155 380,127.5C 379,126.167 378,126.167 377,127.5C 376.501,132.155 376.334,136.821 376.5,141.5C 375.167,141.5 373.833,141.5 372.5,141.5C 372.666,136.821 372.499,132.155 372,127.5C 371,126.167 370,126.167 369,127.5C 368.501,132.155 368.334,136.821 368.5,141.5C 366.214,141.405 364.214,140.738 362.5,139.5C 363.794,137.952 364.461,135.952 364.5,133.5C 364.333,131.5 364.167,129.5 364,127.5C 363,126.167 362,126.167 361,127.5C 360.501,131.152 360.335,134.818 360.5,138.5C 356.518,136.183 353.185,133.183 350.5,129.5C 350.145,126.933 349.479,124.433 348.5,122C 348.57,121.235 348.903,120.735 349.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#032b51",
    d: "M 380.5,141.5 C 379.167,141.5 377.833,141.5 376.5,141.5C 376.334,136.821 376.501,132.155 377,127.5C 378,126.167 379,126.167 380,127.5C 380.499,132.155 380.666,136.821 380.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#032c52",
    d: "M 372.5,141.5 C 371.167,141.5 369.833,141.5 368.5,141.5C 368.334,136.821 368.501,132.155 369,127.5C 370,126.167 371,126.167 372,127.5C 372.499,132.155 372.666,136.821 372.5,141.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8555a",
    d: "M 345.5,119.5 C 346.693,119.97 347.36,120.97 347.5,122.5C 347.167,123.5 346.833,124.5 346.5,125.5C 345.534,123.604 345.201,121.604 345.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd5d50",
    d: "M 398.5,117.5 C 399.167,117.5 399.833,117.5 400.5,117.5C 400.5,118.5 400.5,119.5 400.5,120.5C 399.833,120.5 399.167,120.5 398.5,120.5C 398.5,119.5 398.5,118.5 398.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8d398",
    d: "M 351.5,117.5 C 367.167,117.5 382.833,117.5 398.5,117.5C 398.5,118.5 398.5,119.5 398.5,120.5C 382.833,120.5 367.167,120.5 351.5,120.5C 351.5,119.5 351.5,118.5 351.5,117.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e46c5f",
    d: "M 349.5,116.5 C 350.492,116.328 351.158,116.662 351.5,117.5C 351.5,118.5 351.5,119.5 351.5,120.5C 350.833,120.5 350.167,120.5 349.5,120.5C 349.5,119.167 349.5,117.833 349.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4dc1b4",
    d: "M 402.5,113.5 C 403.806,116.687 403.806,120.02 402.5,123.5C 401.599,120.205 401.599,116.872 402.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5dc3ac",
    d: "M 345.5,109.5 C 347.026,110.492 347.693,111.992 347.5,114C 347.167,115.167 346.833,116.333 346.5,117.5C 345.52,114.914 345.187,112.247 345.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3a93a1",
    d: "M 348.5,112.5 C 349.5,112.5 350.5,112.5 351.5,112.5C 367.167,112.5 382.833,112.5 398.5,112.5C 399.167,112.5 399.833,112.5 400.5,112.5C 400.5,114.167 400.5,115.833 400.5,117.5C 399.833,117.5 399.167,117.5 398.5,117.5C 382.833,117.5 367.167,117.5 351.5,117.5C 351.158,116.662 350.492,116.328 349.5,116.5C 348.566,115.432 348.232,114.099 348.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fd534c",
    d: "M 398.5,109.5 C 399.167,109.5 399.833,109.5 400.5,109.5C 400.5,110.5 400.5,111.5 400.5,112.5C 399.833,112.5 399.167,112.5 398.5,112.5C 398.5,111.5 398.5,110.5 398.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8d498",
    d: "M 351.5,109.5 C 367.167,109.5 382.833,109.5 398.5,109.5C 398.5,110.5 398.5,111.5 398.5,112.5C 382.833,112.5 367.167,112.5 351.5,112.5C 351.5,111.5 351.5,110.5 351.5,109.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b94a1",
    d: "M 351.5,104.5 C 367.167,104.5 382.833,104.5 398.5,104.5C 399.167,104.5 399.833,104.5 400.5,104.5C 400.5,106.167 400.5,107.833 400.5,109.5C 399.833,109.5 399.167,109.5 398.5,109.5C 382.833,109.5 367.167,109.5 351.5,109.5C 350.791,108.596 349.791,108.263 348.5,108.5C 348.5,107.167 348.5,105.833 348.5,104.5C 349.5,104.5 350.5,104.5 351.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ef9d76",
    d: "M 349.5,101.5 C 350.167,101.5 350.833,101.5 351.5,101.5C 351.5,102.5 351.5,103.5 351.5,104.5C 350.5,104.5 349.5,104.5 348.5,104.5C 348.5,105.833 348.5,107.167 348.5,108.5C 349.791,108.263 350.791,108.596 351.5,109.5C 351.5,110.5 351.5,111.5 351.5,112.5C 350.5,112.5 349.5,112.5 348.5,112.5C 348.173,110.512 347.84,108.512 347.5,106.5C 347.436,104.443 348.102,102.777 349.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc4d49",
    d: "M 398.5,101.5 C 399.167,101.5 399.833,101.5 400.5,101.5C 400.5,102.5 400.5,103.5 400.5,104.5C 399.833,104.5 399.167,104.5 398.5,104.5C 398.5,103.5 398.5,102.5 398.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6d398",
    d: "M 351.5,101.5 C 367.167,101.5 382.833,101.5 398.5,101.5C 398.5,102.5 398.5,103.5 398.5,104.5C 382.833,104.5 367.167,104.5 351.5,104.5C 351.5,103.5 351.5,102.5 351.5,101.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c13f4e",
    d: "M 353.5,136.5 C 355.595,136.76 356.928,137.926 357.5,140C 357.252,141.749 356.252,142.582 354.5,142.5C 353.859,141.518 353.193,140.518 352.5,139.5C 353.127,138.583 353.461,137.583 353.5,136.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#be3848",
    d: "M 389.5,139.5 C 391.484,139.383 393.15,140.05 394.5,141.5C 392.207,143.23 389.707,144.563 387,145.5C 385.978,144.646 385.145,143.646 384.5,142.5C 386.36,141.675 388.026,140.675 389.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f3da",
    d: "M 404.5,137.5 C 404.577,138.75 405.244,139.583 406.5,140C 464.536,157.283 522.87,175.116 581.5,193.5C 551.167,193.5 520.833,193.5 490.5,193.5C 460.433,176.132 429.766,159.799 398.5,144.5C 400.529,142.142 402.529,139.808 404.5,137.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc3346",
    d: "M 363.5,144.5 C 361.833,144.5 360.167,144.5 358.5,144.5C 358.5,143.167 358.5,141.833 358.5,140.5C 361.588,140.197 363.254,141.53 363.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e294f",
    d: "M 364.5,144.5 C 371.354,144.176 378.021,144.509 384.5,145.5C 384.5,147.5 384.5,149.5 384.5,151.5C 383.791,152.404 382.791,152.737 381.5,152.5C 376.833,152.5 372.167,152.5 367.5,152.5C 366.209,152.737 365.209,152.404 364.5,151.5C 364.5,149.167 364.5,146.833 364.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3f909c",
    d: "M 341.5,105.5 C 342.833,105.5 344.167,105.5 345.5,105.5C 344.367,113.421 344.2,121.421 345,129.5C 345.374,131.491 346.207,133.158 347.5,134.5C 348.906,134.973 349.573,135.973 349.5,137.5C 350.167,140.167 351.833,141.833 354.5,142.5C 356.452,144.666 358.952,145.999 362,146.5C 363.03,146.164 363.53,145.497 363.5,144.5C 363.833,144.5 364.167,144.5 364.5,144.5C 364.5,146.833 364.5,149.167 364.5,151.5C 364.167,151.5 363.833,151.5 363.5,151.5C 363.631,150.624 363.298,149.957 362.5,149.5C 355.679,147.591 350.013,143.925 345.5,138.5C 344.192,135.27 343.192,131.936 342.5,128.5C 342.799,120.747 342.466,113.08 341.5,105.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb2f45",
    d: "M 398.5,144.5 C 429.766,159.799 460.433,176.132 490.5,193.5C 475.167,193.5 459.833,193.5 444.5,193.5C 427.575,178.7 410.242,164.367 392.5,150.5C 394.424,148.515 396.424,146.515 398.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4efd6",
    d: "M 345.5,138.5 C 350.013,143.925 355.679,147.591 362.5,149.5C 363.298,149.957 363.631,150.624 363.5,151.5C 364.884,157.223 366.217,162.89 367.5,168.5C 368.08,172.81 368.414,177.143 368.5,181.5C 366.801,181.34 365.134,181.506 363.5,182C 361.756,185.235 360.09,188.402 358.5,191.5C 359.98,177.85 361.313,164.183 362.5,150.5C 360.323,150.414 358.323,149.747 356.5,148.5C 351.557,162.661 347.224,176.994 343.5,191.5C 342.005,191.989 340.671,192.655 339.5,193.5C 335.958,193.813 332.625,193.479 329.5,192.5C 337.471,177.517 345.471,162.517 353.5,147.5C 351.833,146.167 350.167,144.833 348.5,143.5C 334.74,159.916 321.406,176.583 308.5,193.5C 300.167,193.5 291.833,193.5 283.5,193.5C 304.123,176.553 324.789,159.553 345.5,142.5C 346.292,141.3 346.292,139.967 345.5,138.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f0d8",
    d: "M 392.5,150.5 C 410.242,164.367 427.575,178.7 444.5,193.5C 436.5,193.5 428.5,193.5 420.5,193.5C 409.26,180.016 398.26,166.35 387.5,152.5C 387.389,151.883 387.056,151.383 386.5,151C 388.658,150.091 390.658,149.925 392.5,150.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fc343c",
    d: "M 367.5,152.5 C 372.167,152.5 376.833,152.5 381.5,152.5C 381.5,156.833 381.5,161.167 381.5,165.5C 380.167,166.5 378.833,167.5 377.5,168.5C 375.167,168.5 372.833,168.5 370.5,168.5C 370.158,167.662 369.492,167.328 368.5,167.5C 367.608,162.562 367.274,157.562 367.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb2e44",
    d: "M 329.5,192.5 C 328.833,192.5 328.5,192.833 328.5,193.5C 321.833,193.5 315.167,193.5 308.5,193.5C 321.406,176.583 334.74,159.916 348.5,143.5C 350.167,144.833 351.833,146.167 353.5,147.5C 345.471,162.517 337.471,177.517 329.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecca96",
    d: "M 398.5,144.5 C 396.424,146.515 394.424,148.515 392.5,150.5C 390.658,149.925 388.658,150.091 386.5,151C 387.056,151.383 387.389,151.883 387.5,152.5C 385.883,153.038 384.216,153.371 382.5,153.5C 382.5,156.833 382.5,160.167 382.5,163.5C 382.672,164.492 382.338,165.158 381.5,165.5C 381.5,161.167 381.5,156.833 381.5,152.5C 382.791,152.737 383.791,152.404 384.5,151.5C 389.071,149.171 393.738,146.838 398.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb2e44",
    d: "M 387.5,152.5 C 398.26,166.35 409.26,180.016 420.5,193.5C 416.833,193.5 413.167,193.5 409.5,193.5C 408.833,193.5 408.167,193.5 407.5,193.5C 404.713,192.523 401.713,192.19 398.5,192.5C 393.405,182.638 388.071,172.971 382.5,163.5C 382.5,160.167 382.5,156.833 382.5,153.5C 384.216,153.371 385.883,153.038 387.5,152.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5cb9f",
    d: "M 363.5,151.5 C 363.833,151.5 364.167,151.5 364.5,151.5C 365.209,152.404 366.209,152.737 367.5,152.5C 367.274,157.562 367.608,162.562 368.5,167.5C 367.833,167.5 367.5,167.833 367.5,168.5C 366.217,162.89 364.884,157.223 363.5,151.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d06a73",
    d: "M 21.5,159.5 C 22.2309,161.599 22.2309,163.599 21.5,165.5C 20.5481,163.955 20.2148,162.288 20.5,160.5C 18.8967,160.312 17.5634,160.812 16.5,162C 17.7433,163.154 18.7433,164.488 19.5,166C 18.175,165.852 17.0084,166.018 16,166.5C 15.7811,165.062 15.2811,163.729 14.5,162.5C 14.2635,163.247 13.9302,164.08 13.5,165C 12.5509,165.617 11.7175,165.451 11,164.5C 10.1482,165.571 9.31491,166.571 8.5,167.5C 8.5,165.167 8.5,162.833 8.5,160.5C 12.7978,159.8 17.1311,159.467 21.5,159.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f1d7",
    d: "M 382.5,163.5 C 388.071,172.971 393.405,182.638 398.5,192.5C 395.167,192.5 391.833,192.5 388.5,192.5C 388.322,189.784 387.822,187.117 387,184.5C 385.736,182.393 383.903,181.393 381.5,181.5C 380.833,178.167 380.167,174.833 379.5,171.5C 379.704,169.315 380.37,167.315 381.5,165.5C 382.338,165.158 382.672,164.492 382.5,163.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd3548",
    d: "M 358.5,191.5 C 353.5,192.833 348.5,192.833 343.5,191.5C 347.224,176.994 351.557,162.661 356.5,148.5C 358.323,149.747 360.323,150.414 362.5,150.5C 361.313,164.183 359.98,177.85 358.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#3b8f9d",
    d: "M 370.5,168.5 C 372.833,168.5 375.167,168.5 377.5,168.5C 377.5,173.5 377.5,178.5 377.5,183.5C 373.167,183.5 368.833,183.5 364.5,183.5C 366.265,182.539 368.265,182.205 370.5,182.5C 370.5,177.833 370.5,173.167 370.5,168.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bf3b4d",
    d: "M 368.5,167.5 C 369.797,172.267 369.797,176.934 368.5,181.5C 368.414,177.143 368.08,172.81 367.5,168.5C 367.5,167.833 367.833,167.5 368.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#db9593",
    d: "M 736.5,171.5 C 737.222,171.918 737.722,172.584 738,173.5C 738.278,172.584 738.778,171.918 739.5,171.5C 739.5,172.833 739.5,174.167 739.5,175.5C 737.689,176.822 735.689,177.322 733.5,177C 736.035,176.072 737.035,174.238 736.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c34755",
    d: "M 739.5,171.5 C 738.778,171.918 738.278,172.584 738,173.5C 737.722,172.584 737.222,171.918 736.5,171.5C 737.035,174.238 736.035,176.072 733.5,177C 735.689,177.322 737.689,176.822 739.5,175.5C 739.5,177.5 739.5,179.5 739.5,181.5C 737.654,181.222 736.32,181.889 735.5,183.5C 736.59,185.003 737.757,185.336 739,184.5C 739.498,187.482 739.665,190.482 739.5,193.5C 735.833,193.5 732.167,193.5 728.5,193.5C 729.765,192.521 731.099,191.521 732.5,190.5C 735.765,186.346 735.099,185.013 730.5,186.5C 730.649,187.552 730.483,188.552 730,189.5C 729.333,186.833 728.667,186.833 728,189.5C 726.488,188.743 725.154,187.743 724,186.5C 722.187,187.609 721.354,186.942 721.5,184.5C 722.873,184.657 724.207,184.49 725.5,184C 724.692,183.692 724.025,183.192 723.5,182.5C 726.076,181.117 725.742,180.283 722.5,180C 725.12,176.905 727.62,177.071 730,180.5C 730.5,180 731,179.5 731.5,179C 729.089,177.417 726.422,176.417 723.5,176C 722.939,174.434 723.606,173.101 725.5,172C 724.833,170.667 723.833,169.667 722.5,169C 724.002,168.417 725.335,167.584 726.5,166.5C 727.653,165.313 727.653,164.313 726.5,163.5C 726.811,162.522 727.478,161.855 728.5,161.5C 729.72,162.711 730.887,162.711 732,161.5C 731.923,162.738 732.089,163.738 732.5,164.5C 733.216,163.689 734.05,163.022 735,162.5C 736.235,163.615 737.402,163.615 738.5,162.5C 739.484,165.428 739.817,168.428 739.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#da8c8c",
    d: "M 736.5,171.5 C 734.011,171.702 731.677,171.202 729.5,170C 730.448,169.517 731.448,169.351 732.5,169.5C 732.238,168.022 732.571,166.689 733.5,165.5C 733.802,167.445 734.802,169.445 736.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c34852",
    d: "M 379.5,171.5 C 380.167,174.833 380.833,178.167 381.5,181.5C 380.5,181.5 379.5,181.5 378.5,181.5C 378.187,177.958 378.521,174.625 379.5,171.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efd098",
    d: "M 368.5,167.5 C 369.492,167.328 370.158,167.662 370.5,168.5C 370.5,173.167 370.5,177.833 370.5,182.5C 368.265,182.205 366.265,182.539 364.5,183.5C 362.345,185.617 361.345,188.284 361.5,191.5C 354.444,193.41 347.111,194.076 339.5,193.5C 340.671,192.655 342.005,191.989 343.5,191.5C 348.5,192.833 353.5,192.833 358.5,191.5C 360.09,188.402 361.756,185.235 363.5,182C 365.134,181.506 366.801,181.34 368.5,181.5C 369.797,176.934 369.797,172.267 368.5,167.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0c896",
    d: "M 381.5,165.5 C 380.37,167.315 379.704,169.315 379.5,171.5C 378.521,174.625 378.187,177.958 378.5,181.5C 379.5,181.5 380.5,181.5 381.5,181.5C 383.903,181.393 385.736,182.393 387,184.5C 387.822,187.117 388.322,189.784 388.5,192.5C 391.833,192.5 395.167,192.5 398.5,192.5C 401.713,192.19 404.713,192.523 407.5,193.5C 400.833,193.5 394.167,193.5 387.5,193.5C 387.135,190.375 386.302,187.375 385,184.5C 382.619,183.565 380.119,183.232 377.5,183.5C 377.5,178.5 377.5,173.5 377.5,168.5C 378.833,167.5 380.167,166.5 381.5,165.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#03294f",
    d: "M 364.5,183.5 C 368.833,183.5 373.167,183.5 377.5,183.5C 380.119,183.232 382.619,183.565 385,184.5C 386.302,187.375 387.135,190.375 387.5,193.5C 378.435,194.136 369.769,193.47 361.5,191.5C 361.345,188.284 362.345,185.617 364.5,183.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eabfb2",
    d: "M 707.5,190.5 C 709.337,190.639 709.67,191.306 708.5,192.5C 707.702,192.043 707.369,191.376 707.5,190.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e8fa0",
    d: "M 361.5,191.5 C 369.769,193.47 378.435,194.136 387.5,193.5C 394.167,193.5 400.833,193.5 407.5,193.5C 408.167,193.5 408.833,193.5 409.5,193.5C 409.833,194.167 410.167,194.833 410.5,195.5C 411.15,197.435 411.483,199.435 411.5,201.5C 386.5,201.5 361.5,201.5 336.5,201.5C 336.016,198.212 337.016,195.545 339.5,193.5C 347.111,194.076 354.444,193.41 361.5,191.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#291d3d",
    d: "M -0.5,193.5 C 2.5,193.5 5.5,193.5 8.5,193.5C 53.5,193.5 98.5,193.5 143.5,193.5C 174.5,193.5 205.5,193.5 236.5,193.5C 252.167,193.5 267.833,193.5 283.5,193.5C 291.833,193.5 300.167,193.5 308.5,193.5C 315.167,193.5 321.833,193.5 328.5,193.5C 330.969,194.317 333.635,194.817 336.5,195C 333.649,197.248 330.315,198.082 326.5,197.5C 325.178,197.33 324.011,197.663 323,198.5C 322.211,200.712 322.378,202.712 323.5,204.5C 327.634,205.485 331.968,205.818 336.5,205.5C 336.5,204.5 336.5,203.5 336.5,202.5C 339.167,202.5 341.833,202.5 344.5,202.5C 348.373,204.43 352.706,205.097 357.5,204.5C 358.552,203.47 359.886,202.803 361.5,202.5C 364.379,203.795 367.379,204.462 370.5,204.5C 373.698,205.036 376.365,204.369 378.5,202.5C 380.5,202.5 382.5,202.5 384.5,202.5C 385.183,204.176 386.517,204.843 388.5,204.5C 394.181,204.365 399.848,204.032 405.5,203.5C 409.97,204.486 414.637,204.819 419.5,204.5C 420.833,198.5 418.5,196.167 412.5,197.5C 412.167,196.5 411.5,195.833 410.5,195.5C 410.167,194.833 409.833,194.167 409.5,193.5C 413.167,193.5 416.833,193.5 420.5,193.5C 428.5,193.5 436.5,193.5 444.5,193.5C 459.833,193.5 475.167,193.5 490.5,193.5C 520.833,193.5 551.167,193.5 581.5,193.5C 630.5,193.5 679.5,193.5 728.5,193.5C 732.167,193.5 735.833,193.5 739.5,193.5C 742.833,193.5 746.167,193.5 749.5,193.5C 749.5,225.5 749.5,257.5 749.5,289.5C 649.167,289.5 548.833,289.5 448.5,289.5C 448.5,288.5 448.5,287.5 448.5,286.5C 452.167,286.5 455.833,286.5 459.5,286.5C 459.5,284.167 459.5,281.833 459.5,279.5C 454.968,279.182 450.634,279.515 446.5,280.5C 445.861,281.097 445.528,281.93 445.5,283C 446.418,285.086 447.085,287.253 447.5,289.5C 298.167,289.5 148.833,289.5 -0.5,289.5C -0.5,288.5 -0.5,287.5 -0.5,286.5C 3.18174,286.665 6.84841,286.499 10.5,286C 11.8333,283.667 11.8333,281.333 10.5,279C 6.84841,278.501 3.18174,278.335 -0.5,278.5C -0.5,254.167 -0.5,229.833 -0.5,205.5C 2.7131,205.81 5.7131,205.477 8.5,204.5C 9.5,204.5 10.5,204.5 11.5,204.5C 11.6621,202.473 11.4955,200.473 11,198.5C 10.3292,197.748 9.4959,197.414 8.5,197.5C 5.5,197.5 2.5,197.5 -0.5,197.5C -0.5,196.167 -0.5,194.833 -0.5,193.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9f374a",
    d: "M 127.5,197.5 C 125.095,198.768 122.428,199.435 119.5,199.5C 121.635,197.631 124.302,196.964 127.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4e2cd",
    d: "M -0.5,197.5 C 2.5,197.5 5.5,197.5 8.5,197.5C 8.84987,200.041 8.84987,202.374 8.5,204.5C 5.7131,205.477 2.7131,205.81 -0.5,205.5C -0.5,202.833 -0.5,200.167 -0.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b13148",
    d: "M 8.5,197.5 C 9.4959,197.414 10.3292,197.748 11,198.5C 11.4955,200.473 11.6621,202.473 11.5,204.5C 10.5,204.5 9.5,204.5 8.5,204.5C 8.84987,202.374 8.84987,200.041 8.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b63c4e",
    d: "M 17.5,197.5 C 22.1667,197.5 26.8333,197.5 31.5,197.5C 31.5,200.167 31.5,202.833 31.5,205.5C 27.1539,205.666 22.8206,205.499 18.5,205C 17.565,202.619 17.2317,200.119 17.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac2e44",
    d: "M 38.5,197.5 C 42.8461,197.334 47.1794,197.501 51.5,198C 52.5914,200.064 52.7581,202.231 52,204.5C 47.5868,205.632 43.0868,205.799 38.5,205C 37.2215,202.502 37.2215,200.002 38.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b73e50",
    d: "M 58.5,197.5 C 62.8461,197.334 67.1794,197.501 71.5,198C 72.8333,200.333 72.8333,202.667 71.5,205C 67.1794,205.499 62.8461,205.666 58.5,205.5C 58.5,202.833 58.5,200.167 58.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ae2b43",
    d: "M 78.5,197.5 C 83.1667,197.5 87.8333,197.5 92.5,197.5C 92.5,200.167 92.5,202.833 92.5,205.5C 88.1539,205.666 83.8206,205.499 79.5,205C 78.565,202.619 78.2317,200.119 78.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b32e45",
    d: "M 113.5,201.5 C 109.123,203.734 104.457,204.734 99.5,204.5C 98.1888,202.44 98.1888,200.274 99.5,198C 103.833,197.333 108.167,197.333 112.5,198C 113.337,199.011 113.67,200.178 113.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e1cd",
    d: "M 127.5,197.5 C 133.067,196.753 134.9,199.087 133,204.5C 128.599,205.467 124.099,205.8 119.5,205.5C 119.5,203.5 119.5,201.5 119.5,199.5C 122.428,199.435 125.095,198.768 127.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e4e2cd",
    d: "M 139.5,197.5 C 144.167,197.5 148.833,197.5 153.5,197.5C 153.5,200.167 153.5,202.833 153.5,205.5C 149.154,205.666 144.821,205.499 140.5,205C 139.565,202.619 139.232,200.119 139.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0deca",
    d: "M 160.5,197.5 C 164.846,197.334 169.179,197.501 173.5,198C 174.591,200.064 174.758,202.231 174,204.5C 169.587,205.632 165.087,205.799 160.5,205C 159.221,202.502 159.221,200.002 160.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3e1ce",
    d: "M 180.5,197.5 C 184.846,197.334 189.179,197.501 193.5,198C 194.591,200.064 194.758,202.231 194,204.5C 189.667,205.167 185.333,205.833 181,206.5C 180.502,203.518 180.335,200.518 180.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e5e3d0",
    d: "M 200.5,197.5 C 205.167,197.5 209.833,197.5 214.5,197.5C 216.238,203.916 213.904,206.583 207.5,205.5C 201.096,206.583 198.762,203.916 200.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d7cdbd",
    d: "M 227.5,197.5 C 225.365,199.071 223.032,200.404 220.5,201.5C 220.33,200.178 220.663,199.011 221.5,198C 223.473,197.505 225.473,197.338 227.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac2841",
    d: "M 227.5,197.5 C 234.659,195.82 236.993,198.32 234.5,205C 230.167,205.667 225.833,205.667 221.5,205C 220.663,203.989 220.33,202.822 220.5,201.5C 223.032,200.404 225.365,199.071 227.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ac2841",
    d: "M 241.5,197.5 C 245.846,197.334 250.179,197.501 254.5,198C 255.833,200.333 255.833,202.667 254.5,205C 250.179,205.499 245.846,205.666 241.5,205.5C 241.5,202.833 241.5,200.167 241.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b02e44",
    d: "M 275.5,200.5 C 272.883,201.786 270.55,203.453 268.5,205.5C 262.326,206.827 260.159,204.494 262,198.5C 266.401,197.533 270.901,197.2 275.5,197.5C 275.5,198.5 275.5,199.5 275.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0deca",
    d: "M 282.5,197.5 C 286.846,197.334 291.179,197.501 295.5,198C 296.591,200.064 296.758,202.231 296,204.5C 291.587,205.632 287.087,205.799 282.5,205C 281.221,202.502 281.221,200.002 282.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b22942",
    d: "M 315.5,198.5 C 316.811,200.56 316.811,202.726 315.5,205C 310.98,205.814 306.646,205.647 302.5,204.5C 302.261,202.533 302.594,200.699 303.5,199C 307.486,198.501 311.486,198.334 315.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b23448",
    d: "M 326.5,197.5 C 326.5,197.833 326.5,198.167 326.5,198.5C 324.992,200.181 323.992,202.181 323.5,204.5C 322.378,202.712 322.211,200.712 323,198.5C 324.011,197.663 325.178,197.33 326.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#eae7d0",
    d: "M 326.5,198.5 C 329.167,198.5 331.833,198.5 334.5,198.5C 334.229,200.38 334.896,201.713 336.5,202.5C 336.5,203.5 336.5,204.5 336.5,205.5C 331.968,205.818 327.634,205.485 323.5,204.5C 323.992,202.181 324.992,200.181 326.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b53147",
    d: "M 412.5,197.5 C 418.5,196.167 420.833,198.5 419.5,204.5C 414.637,204.819 409.97,204.486 405.5,203.5C 407.857,203.663 410.19,203.497 412.5,203C 413.752,201.172 413.752,199.339 412.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e6d1",
    d: "M 429.5,204.5 C 428.136,202.809 426.803,201.142 425.5,199.5C 425.611,198.883 425.944,198.383 426.5,198C 430.821,197.501 435.154,197.334 439.5,197.5C 439.5,199.833 439.5,202.167 439.5,204.5C 436.167,204.5 432.833,204.5 429.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6decb",
    d: "M 453.5,197.5 C 453.389,198.117 453.056,198.617 452.5,199C 454.396,201.068 456.396,202.901 458.5,204.5C 454.167,204.5 449.833,204.5 445.5,204.5C 444.406,198.095 447.073,195.762 453.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a72d44",
    d: "M 453.5,197.5 C 455.792,197.244 457.959,197.577 460,198.5C 460.167,199.5 460.333,200.5 460.5,201.5C 460.36,203.03 459.693,204.03 458.5,204.5C 456.396,202.901 454.396,201.068 452.5,199C 453.056,198.617 453.389,198.117 453.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b42d45",
    d: "M 467.5,197.5 C 471.514,197.334 475.514,197.501 479.5,198C 480.423,200.041 480.756,202.208 480.5,204.5C 475.833,204.5 471.167,204.5 466.5,204.5C 466.298,202.05 466.631,199.717 467.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b12841",
    d: "M 487.5,197.5 C 491.514,197.334 495.514,197.501 499.5,198C 500.423,200.041 500.756,202.208 500.5,204.5C 495.833,204.5 491.167,204.5 486.5,204.5C 486.298,202.05 486.631,199.717 487.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfddc9",
    d: "M 511.5,204.5 C 510.035,203.263 508.368,202.263 506.5,201.5C 506.33,200.178 506.663,199.011 507.5,198C 511.833,197.333 516.167,197.333 520.5,198C 521.423,200.041 521.756,202.208 521.5,204.5C 518.167,204.5 514.833,204.5 511.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6e4d0",
    d: "M 528.5,197.5 C 532.514,197.334 536.514,197.501 540.5,198C 541.423,200.041 541.756,202.208 541.5,204.5C 536.833,204.5 532.167,204.5 527.5,204.5C 527.298,202.05 527.631,199.717 528.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f4da",
    d: "M 547.5,198.5 C 552.167,198.5 556.833,198.5 561.5,198.5C 561.5,200.5 561.5,202.5 561.5,204.5C 556.833,204.5 552.167,204.5 547.5,204.5C 547.5,202.5 547.5,200.5 547.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dedcc9",
    d: "M 568.5,197.5 C 572.846,197.334 577.179,197.501 581.5,198C 582.423,200.041 582.756,202.208 582.5,204.5C 577.5,204.5 572.5,204.5 567.5,204.5C 567.298,202.05 567.631,199.717 568.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1eed7",
    d: "M 588.5,198.5 C 593.167,198.5 597.833,198.5 602.5,198.5C 602.5,200.5 602.5,202.5 602.5,204.5C 597.833,204.5 593.167,204.5 588.5,204.5C 588.5,202.5 588.5,200.5 588.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd3549",
    d: "M 618.5,204.5 C 615.358,203.21 612.025,202.21 608.5,201.5C 608.5,200.5 608.5,199.5 608.5,198.5C 613.167,198.5 617.833,198.5 622.5,198.5C 622.5,200.5 622.5,202.5 622.5,204.5C 621.167,204.5 619.833,204.5 618.5,204.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b12841",
    d: "M 628.5,198.5 C 633.5,198.5 638.5,198.5 643.5,198.5C 643.5,200.5 643.5,202.5 643.5,204.5C 638.5,204.5 633.5,204.5 628.5,204.5C 628.5,202.5 628.5,200.5 628.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bb2d44",
    d: "M 669.5,198.5 C 674.167,198.5 678.833,198.5 683.5,198.5C 683.5,200.5 683.5,202.5 683.5,204.5C 678.833,204.5 674.167,204.5 669.5,204.5C 669.5,202.5 669.5,200.5 669.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b62a42",
    d: "M 691.5,197.5 C 695.846,197.334 700.179,197.501 704.5,198C 705.423,200.041 705.756,202.208 705.5,204.5C 700.833,204.5 696.167,204.5 691.5,204.5C 691.5,202.167 691.5,199.833 691.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b42840",
    d: "M 725.5,198.5 C 725.739,200.467 725.406,202.301 724.5,204C 720.514,204.499 716.514,204.666 712.5,204.5C 711.532,202.393 711.198,200.059 711.5,197.5C 716.363,197.181 721.03,197.514 725.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e6d0",
    d: "M 739.5,197.5 C 746.021,196.34 748.021,198.673 745.5,204.5C 743.5,204.5 741.5,204.5 739.5,204.5C 739.15,201.959 739.15,199.626 739.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bd394a",
    d: "M 425.5,199.5 C 426.803,201.142 428.136,202.809 429.5,204.5C 428.167,204.5 426.833,204.5 425.5,204.5C 425.5,202.833 425.5,201.167 425.5,199.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b84e59",
    d: "M 739.5,197.5 C 739.15,199.626 739.15,201.959 739.5,204.5C 741.5,204.5 743.5,204.5 745.5,204.5C 741.1,205.823 736.6,205.823 732,204.5C 730.393,198.082 732.893,195.749 739.5,197.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ded5c3",
    d: "M 275.5,200.5 C 275.5,202.167 275.5,203.833 275.5,205.5C 273.167,205.5 270.833,205.5 268.5,205.5C 270.55,203.453 272.883,201.786 275.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#78354a",
    d: "M 315.5,198.5 C 311.486,198.334 307.486,198.501 303.5,199C 302.594,200.699 302.261,202.533 302.5,204.5C 301.189,202.44 301.189,200.274 302.5,198C 307.02,197.186 311.354,197.353 315.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e7ce9f",
    d: "M 329.5,192.5 C 332.625,193.479 335.958,193.813 339.5,193.5C 337.016,195.545 336.016,198.212 336.5,201.5C 361.5,201.5 386.5,201.5 411.5,201.5C 411.483,199.435 411.15,197.435 410.5,195.5C 411.5,195.833 412.167,196.5 412.5,197.5C 413.752,199.339 413.752,201.172 412.5,203C 410.19,203.497 407.857,203.663 405.5,203.5C 399.848,204.032 394.181,204.365 388.5,204.5C 387.817,202.824 386.483,202.157 384.5,202.5C 382.5,202.5 380.5,202.5 378.5,202.5C 375.302,201.964 372.635,202.631 370.5,204.5C 367.379,204.462 364.379,203.795 361.5,202.5C 359.886,202.803 358.552,203.47 357.5,204.5C 353.627,202.57 349.294,201.903 344.5,202.5C 341.833,202.5 339.167,202.5 336.5,202.5C 334.896,201.713 334.229,200.38 334.5,198.5C 331.833,198.5 329.167,198.5 326.5,198.5C 326.5,198.167 326.5,197.833 326.5,197.5C 330.315,198.082 333.649,197.248 336.5,195C 333.635,194.817 330.969,194.317 328.5,193.5C 328.5,192.833 328.833,192.5 329.5,192.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3ebd5",
    d: "M 608.5,201.5 C 612.025,202.21 615.358,203.21 618.5,204.5C 615.167,204.5 611.833,204.5 608.5,204.5C 608.5,203.5 608.5,202.5 608.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cb5e5f",
    d: "M 378.5,202.5 C 376.365,204.369 373.698,205.036 370.5,204.5C 372.635,202.631 375.302,201.964 378.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ca6b68",
    d: "M 384.5,202.5 C 386.483,202.157 387.817,202.824 388.5,204.5C 386.517,204.843 385.183,204.176 384.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bc374d",
    d: "M 649.5,198.5 C 654.167,198.5 658.833,198.5 663.5,198.5C 663.5,200.5 663.5,202.5 663.5,204.5C 658.833,204.5 654.167,204.5 649.5,204.5C 649.5,202.5 649.5,200.5 649.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c14251",
    d: "M 344.5,202.5 C 349.294,201.903 353.627,202.57 357.5,204.5C 352.706,205.097 348.373,204.43 344.5,202.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b54654",
    d: "M 506.5,201.5 C 508.368,202.263 510.035,203.263 511.5,204.5C 509.833,204.5 508.167,204.5 506.5,204.5C 506.5,203.5 506.5,202.5 506.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aa9695",
    d: "M 113.5,201.5 C 113.67,202.822 113.337,203.989 112.5,205C 107.98,205.814 103.646,205.647 99.5,204.5C 104.457,204.734 109.123,203.734 113.5,201.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#692741",
    d: "M 725.5,198.5 C 726.811,200.56 726.811,202.726 725.5,205C 720.98,205.814 716.646,205.647 712.5,204.5C 716.514,204.666 720.514,204.499 724.5,204C 725.406,202.301 725.739,200.467 725.5,198.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2edf0",
    d: "M 341.5,213.5 C 345.615,215.052 349.948,215.885 354.5,216C 355.047,216.925 355.713,217.758 356.5,218.5C 369.554,214.252 382.388,214.585 395,219.5C 396.171,218.107 397.671,217.273 399.5,217C 405.146,216.907 410.646,216.073 416,214.5C 423.32,216.164 430.653,217.497 438,218.5C 438.903,217.299 440.069,216.465 441.5,216C 452.302,214.894 462.969,215.561 473.5,218C 475.946,221.717 478.279,225.551 480.5,229.5C 481.5,229.167 482.167,228.5 482.5,227.5C 478.114,224.682 477.447,221.182 480.5,217C 486.5,216.333 492.5,216.333 498.5,217C 499.894,217.956 500.561,219.289 500.5,221C 498.85,224.014 498.35,227.181 499,230.5C 499.465,229.069 500.299,227.903 501.5,227C 504.553,226.821 507.553,226.321 510.5,225.5C 506.562,222.57 506.562,219.737 510.5,217C 517.66,215.634 524.826,215.134 532,215.5C 533.605,216.101 534.938,217.101 536,218.5C 536.333,221.167 536.667,223.833 537,226.5C 539.558,229.822 541.558,233.489 543,237.5C 546.18,241.012 549.346,244.512 552.5,248C 551.667,250.167 550.167,251.667 548,252.5C 544.478,251.578 540.978,250.578 537.5,249.5C 532.645,251.782 529.478,250.448 528,245.5C 526.009,247.905 523.676,248.572 521,247.5C 518.376,251.934 515.043,252.6 511,249.5C 508.631,250.551 506.131,251.218 503.5,251.5C 495.853,250.768 488.187,250.268 480.5,250C 479.107,248.829 478.273,247.329 478,245.5C 472.764,247.461 467.764,249.794 463,252.5C 455.248,250.984 447.414,250.151 439.5,250C 438.333,249.5 437.5,248.667 437,247.5C 434.825,250.519 431.992,252.519 428.5,253.5C 424.988,252.177 421.822,250.177 419,247.5C 418.872,244.486 418.872,241.486 419,238.5C 417.603,239.226 416.769,240.393 416.5,242C 418.293,245.287 417.626,247.953 414.5,250C 409.167,250.667 403.833,250.667 398.5,250C 397.107,248.829 396.273,247.329 396,245.5C 395.535,246.931 394.701,248.097 393.5,249C 380.912,252.725 368.579,252.225 356.5,247.5C 351.758,249.633 346.758,250.967 341.5,251.5C 341.671,253.993 340.671,255.826 338.5,257C 329.438,257.881 320.438,257.548 311.5,256C 305.514,254.592 300.348,251.758 296,247.5C 293.082,251.883 289.415,252.55 285,249.5C 279.681,254.552 274.514,254.552 269.5,249.5C 258.47,252.284 247.47,252.118 236.5,249C 235.333,248.5 234.5,247.667 234,246.5C 231.356,248.964 228.19,250.464 224.5,251C 215.831,251.156 207.164,250.823 198.5,250C 197.101,248.938 196.101,247.605 195.5,246C 198.918,241.848 199.252,237.515 196.5,233C 197.897,231.039 198.897,228.872 199.5,226.5C 197.772,224.771 196.439,222.771 195.5,220.5C 195.632,218.399 196.632,216.899 198.5,216C 207.656,216.81 216.822,216.643 226,215.5C 229.405,215.054 232.239,216.054 234.5,218.5C 246.683,214.526 258.85,214.526 271,218.5C 272.509,216.119 274.675,215.119 277.5,215.5C 282.491,216.09 287.491,216.59 292.5,217C 294.121,219.166 294.955,221.666 295,224.5C 296.333,226.5 297.667,228.5 299,230.5C 299.694,226.998 299.194,223.664 297.5,220.5C 297.529,218.971 298.196,217.804 299.5,217C 313.42,215.907 327.42,215.74 341.5,216.5C 341.5,215.5 341.5,214.5 341.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#918b9b",
    d: "M 689.5,213.5 C 690.874,215.517 690.707,217.517 689,219.5C 688.82,217.512 688.986,215.512 689.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c98693",
    d: "M 226.5,219.5 C 217.833,220.167 209.167,220.833 200.5,221.5C 199.957,221.44 199.624,221.107 199.5,220.5C 208.475,219.502 217.475,219.168 226.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a33348",
    d: "M 226.5,219.5 C 227.5,219.5 228.5,219.5 229.5,219.5C 229.382,222.688 228.549,225.688 227,228.5C 224.833,227.667 223.333,226.167 222.5,224C 218.909,223.211 215.409,223.378 212,224.5C 211.5,230.825 211.334,237.158 211.5,243.5C 215.226,243.823 218.893,243.489 222.5,242.5C 224.19,239.976 226.357,237.976 229,236.5C 229.218,239.426 229.718,242.26 230.5,245C 220.312,247.658 209.978,247.991 199.5,246C 202.486,242.248 203.153,238.082 201.5,233.5C 203.436,229.955 203.769,226.289 202.5,222.5C 201.817,222.137 201.15,221.804 200.5,221.5C 209.167,220.833 217.833,220.167 226.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4364a",
    d: "M 245.5,219.5 C 253.613,219.239 261.613,220.073 269.5,222C 268.106,222.956 267.439,224.289 267.5,226C 268.077,228.657 269.077,231.157 270.5,233.5C 267.075,237.108 266.741,240.941 269.5,245C 258.828,248.283 248.162,248.283 237.5,245C 239.2,240.594 238.533,236.594 235.5,233C 239.074,229.476 239.407,225.642 236.5,221.5C 239.642,220.833 242.642,220.166 245.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5384b",
    d: "M 321.5,220.5 C 331.658,219.341 341.992,219.175 352.5,220C 351.812,222.929 350.812,225.763 349.5,228.5C 345.553,224.157 340.553,222.49 334.5,223.5C 333.439,229.865 333.439,236.198 334.5,242.5C 337.784,243.657 341.118,243.824 344.5,243C 345.848,240.487 347.848,238.653 350.5,237.5C 351.273,239.813 351.94,242.146 352.5,244.5C 348.754,246.437 344.754,247.437 340.5,247.5C 334.507,246.924 328.507,246.424 322.5,246C 325.692,241.937 326.025,237.77 323.5,233.5C 325.882,230.207 326.882,226.54 326.5,222.5C 324.486,222.608 322.82,221.942 321.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a33247",
    d: "M 368.5,219.5 C 376.306,219.105 383.972,219.938 391.5,222C 389.887,226.203 390.553,230.036 393.5,233.5C 390.008,237.099 389.675,240.932 392.5,245C 381.92,248.257 371.253,248.257 360.5,245C 362.113,240.797 361.447,236.964 358.5,233.5C 361.691,229.777 362.024,225.944 359.5,222C 362.628,221.159 365.628,220.325 368.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a33348",
    d: "M 415.5,218.5 C 422.387,220.137 429.387,221.304 436.5,222C 434.649,222.837 432.816,223.671 431,224.5C 430.82,226.488 430.986,228.488 431.5,230.5C 426.293,231.351 426.293,232.684 431.5,234.5C 432.321,237.447 432.821,240.447 433,243.5C 433.5,244 434,244.5 434.5,245C 432.359,246.308 430.359,247.808 428.5,249.5C 426.5,247.833 424.5,246.167 422.5,244.5C 423.795,241.634 423.795,238.801 422.5,236C 421.391,235.362 420.225,234.862 419,234.5C 416.567,235.479 414.067,236.145 411.5,236.5C 411.616,239.86 411.949,243.193 412.5,246.5C 408.486,246.666 404.486,246.499 400.5,246C 405.405,242.038 405.739,237.704 401.5,233C 403.227,230.096 403.893,226.93 403.5,223.5C 401.654,223.778 400.32,223.111 399.5,221.5C 405.082,221.01 410.416,220.01 415.5,218.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a43549",
    d: "M 439.5,220.5 C 450.414,219.078 461.414,219.411 472.5,221.5C 472.841,225.354 474.174,228.854 476.5,232C 474.71,235.583 474.043,239.416 474.5,243.5C 473.127,243.343 471.793,243.51 470.5,244C 467.682,245.338 465.015,246.838 462.5,248.5C 454.933,246.907 447.266,246.074 439.5,246C 442.759,244.75 444.425,242.417 444.5,239C 444.172,233.888 444.005,228.722 444,223.5C 442.729,222.117 441.229,221.117 439.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a43449",
    d: "M 274.5,220.5 C 275.622,219.844 276.955,219.511 278.5,219.5C 282.5,220 286.5,220.5 290.5,221C 288.053,222.229 287.887,223.729 290,225.5C 293.921,231.426 298.588,236.759 304,241.5C 303.847,235.2 303.514,228.867 303,222.5C 302.5,222 302,221.5 301.5,221C 306.85,220.361 312.183,220.028 317.5,220C 311.301,222.884 309.968,227.217 313.5,233C 311.561,237.658 311.061,242.491 312,247.5C 314.861,250.472 318.194,251.139 322,249.5C 327.182,250.708 332.349,251.875 337.5,253C 317.844,256.672 301.677,250.838 289,235.5C 287.849,239.829 288.682,243.662 291.5,247C 289.217,247.291 287.05,246.791 285,245.5C 282.127,247.678 278.96,248.844 275.5,249C 281.371,244.646 282.704,239.313 279.5,233C 283.318,226.547 281.651,222.38 274.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a33247",
    d: "M 482.5,220.5 C 487.179,220.334 491.845,220.501 496.5,221C 495.07,222.907 494.404,225.074 494.5,227.5C 495.833,231.167 495.833,234.833 494.5,238.5C 494.318,241.816 495.651,244.316 498.5,246C 493.167,246.667 487.833,246.667 482.5,246C 487.313,241.959 487.646,237.625 483.5,233C 486.097,230.683 486.93,227.85 486,224.5C 483.929,223.897 482.762,222.564 482.5,220.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a4354a",
    d: "M 515.5,219.5 C 521.567,220.022 527.567,220.188 533.5,220C 532.398,222.401 532.231,224.901 533,227.5C 535.152,230.634 536.818,233.968 538,237.5C 540.5,241.333 543.667,244.5 547.5,247C 544.006,246.905 540.506,246.405 537,245.5C 535.774,245.645 534.607,245.978 533.5,246.5C 532.696,243.56 531.363,240.893 529.5,238.5C 527.465,240.372 525.298,242.039 523,243.5C 520.981,241.757 518.814,240.59 516.5,240C 515.018,242.592 515.352,244.925 517.5,247C 515.095,247.148 512.761,246.648 510.5,245.5C 507.972,246.942 505.305,247.442 502.5,247C 506.591,243.897 509.591,239.897 511.5,235C 509.044,233.289 506.377,231.956 503.5,231C 506.917,230.975 510.25,230.808 513.5,230.5C 514.695,228.249 515.695,225.915 516.5,223.5C 515.286,221.931 513.619,221.098 511.5,221C 513.058,220.79 514.391,220.29 515.5,219.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f1f3",
    d: "M 248.5,223.5 C 252.548,223.395 256.548,223.728 260.5,224.5C 260.666,230.509 260.499,236.509 260,242.5C 250.088,246.961 245.588,243.961 246.5,233.5C 246.591,229.902 247.257,226.569 248.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f3f4",
    d: "M 369.5,223.5 C 373.881,223.372 378.215,223.705 382.5,224.5C 382.5,230.833 382.5,237.167 382.5,243.5C 377.83,245.133 373.33,244.8 369,242.5C 368.21,236.085 368.376,229.752 369.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#faf5f6",
    d: "M 411.5,223.5 C 415.167,223.5 418.833,223.5 422.5,223.5C 422.739,225.467 422.406,227.301 421.5,229C 418.24,229.975 415.073,231.142 412,232.5C 411.502,229.518 411.335,226.518 411.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6eff0",
    d: "M 454.5,223.5 C 458.167,223.5 461.833,223.5 465.5,223.5C 465.804,226.579 466.804,229.413 468.5,232C 467.065,234.659 466.065,237.492 465.5,240.5C 461.96,243.115 457.96,244.115 453.5,243.5C 451.885,236.586 452.218,229.919 454.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2e2342",
    d: "M 316.5,224.5 C 322.418,224.206 323.585,226.206 320,230.5C 319.222,233.275 319.722,235.775 321.5,238C 320.715,241.029 319.549,243.862 318,246.5C 316.303,245.636 315.137,244.303 314.5,242.5C 317.64,237.547 317.974,232.547 315.5,227.5C 315.685,226.416 316.018,225.416 316.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#342947",
    d: "M 394.5,223.5 C 396.43,224.763 398.097,226.43 399.5,228.5C 397.843,232.361 396.343,232.361 395,228.5C 394.506,226.866 394.34,225.199 394.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#382d4b",
    d: "M 232.5,223.5 C 235.449,227.082 234.783,230.082 230.5,232.5C 230.167,232.333 229.833,232.167 229.5,232C 231.585,229.581 232.585,226.747 232.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#291e3d",
    d: "M 438.5,225.5 C 439.693,225.97 440.36,226.97 440.5,228.5C 439.295,231.847 439.295,235.18 440.5,238.5C 440.272,240.397 439.272,241.73 437.5,242.5C 436.669,238.359 436.003,234.192 435.5,230C 435.557,227.791 436.557,226.291 438.5,225.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#342947",
    d: "M 355.5,224.5 C 356.497,224.47 357.164,224.97 357.5,226C 352.112,235.788 351.446,235.288 355.5,224.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#291e3e",
    d: "M 215.5,227.5 C 217.199,227.34 218.866,227.506 220.5,228C 221.848,230.513 223.848,232.347 226.5,233.5C 223.804,234.851 221.47,236.684 219.5,239C 218.207,239.49 216.873,239.657 215.5,239.5C 215.5,235.5 215.5,231.5 215.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#291e3d",
    d: "M 249.5,227.5 C 251.833,227.5 254.167,227.5 256.5,227.5C 256.824,231.555 256.491,235.555 255.5,239.5C 253.584,240.248 251.584,240.248 249.5,239.5C 249.5,235.5 249.5,231.5 249.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b203f",
    d: "M 338.5,227.5 C 340.288,227.215 341.955,227.548 343.5,228.5C 344.791,230.959 346.791,232.459 349.5,233C 346.872,234.626 344.539,236.626 342.5,239C 340.866,239.494 339.199,239.66 337.5,239.5C 337.395,235.452 337.728,231.452 338.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#261b3b",
    d: "M 372.5,227.5 C 374.5,227.5 376.5,227.5 378.5,227.5C 378.824,231.555 378.491,235.555 377.5,239.5C 376.167,240.833 374.833,240.833 373.5,239.5C 372.509,235.555 372.176,231.555 372.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b203f",
    d: "M 456.5,227.5 C 458.5,227.5 460.5,227.5 462.5,227.5C 463.968,231.307 463.635,234.974 461.5,238.5C 459.929,239.309 458.262,239.643 456.5,239.5C 456.5,235.5 456.5,231.5 456.5,227.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7ebed",
    d: "M 522.5,226.5 C 524.992,228.28 526.659,230.78 527.5,234C 525.168,239.655 522.168,239.988 518.5,235C 520.246,232.341 521.58,229.508 522.5,226.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#352b49",
    d: "M 272.5,222.5 C 277.568,224.7 278.568,228.033 275.5,232.5C 275.697,234.682 276.364,236.682 277.5,238.5C 276.351,240.797 275.185,243.13 274,245.5C 273.365,243.382 272.531,241.382 271.5,239.5C 273.363,237.96 274.363,235.96 274.5,233.5C 273.786,230.93 272.786,228.43 271.5,226C 271.989,224.862 272.322,223.695 272.5,222.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#302543",
    d: "M 499.5,233.5 C 501.142,235.081 503.142,235.747 505.5,235.5C 505.498,240.353 503.331,242.353 499,241.5C 498.398,238.779 498.565,236.113 499.5,233.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#433955",
    d: "M 396.5,235.5 C 397.5,235.5 398.5,235.5 399.5,235.5C 400.903,238.951 399.903,241.618 396.5,243.5C 393.937,240.92 393.937,238.253 396.5,235.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#342947",
    d: "M 479.5,234.5 C 483.514,237.528 483.348,240.528 479,243.5C 478.366,240.445 478.532,237.445 479.5,234.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#332947",
    d: "M 355.5,237.5 C 356.914,239.044 357.247,240.711 356.5,242.5C 355.548,240.955 355.215,239.288 355.5,237.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#8b8596",
    d: "M 284.5,264.5 C 283.833,264.5 283.167,264.5 282.5,264.5C 281.167,264.5 279.833,264.5 278.5,264.5C 277.508,264.328 276.842,264.662 276.5,265.5C 275.448,265.649 274.448,265.483 273.5,265C 273.833,264.667 274.167,264.333 274.5,264C 279.271,263.174 282.604,263.341 284.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#958f9f",
    d: "M 343.5,264.5 C 342.624,264.369 341.957,264.702 341.5,265.5C 342.243,266.182 342.909,266.849 343.5,267.5C 342.835,269.369 342.169,271.369 341.5,273.5C 340.833,270.833 340.167,268.167 339.5,265.5C 335.363,267.236 334.696,269.736 337.5,273C 336.552,273.483 335.552,273.649 334.5,273.5C 334.762,272.022 334.429,270.689 333.5,269.5C 332.269,270.651 332.269,271.817 333.5,273C 332.906,273.464 332.239,273.631 331.5,273.5C 331.665,270.482 331.498,267.482 331,264.5C 330.817,267.365 330.317,270.031 329.5,272.5C 329.808,270.076 329.474,267.743 328.5,265.5C 327.833,266.167 327.167,266.833 326.5,267.5C 325.158,265.995 323.492,265.328 321.5,265.5C 322.134,264.053 323.301,263.387 325,263.5C 331.771,264.022 337.938,264.355 343.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a7a2b0",
    d: "M 393.5,264.5 C 397.512,263.982 401.845,263.816 406.5,264C 407.747,265.494 407.747,266.994 406.5,268.5C 405.494,268.062 405.494,267.396 406.5,266.5C 405.311,265.571 403.978,265.238 402.5,265.5C 402.5,268.167 402.5,270.833 402.5,273.5C 401.448,273.649 400.448,273.483 399.5,273C 400.777,270.534 400.777,268.034 399.5,265.5C 397.413,267.745 396.079,270.412 395.5,273.5C 394.833,270.358 394.166,267.358 393.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f2f1f3",
    d: "M 331.5,273.5 C 329.599,273.754 328.933,273.42 329.5,272.5C 330.317,270.031 330.817,267.365 331,264.5C 331.498,267.482 331.665,270.482 331.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f9f9fa",
    d: "M 369.5,272.5 C 369.158,273.338 368.492,273.672 367.5,273.5C 367.335,270.482 367.502,267.482 368,264.5C 368.183,267.365 368.683,270.031 369.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9791a1",
    d: "M 413.5,265.5 C 414.635,263.787 416.302,263.12 418.5,263.5C 418.649,264.552 418.483,265.552 418,266.5C 416.644,265.62 415.144,265.286 413.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a19cab",
    d: "M 442.5,263.5 C 444.199,263.34 445.866,263.506 447.5,264C 446.874,264.75 446.374,265.584 446,266.5C 444.601,265.773 443.101,265.273 441.5,265C 442.056,264.617 442.389,264.117 442.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c2bfc8",
    d: "M 287.5,271.5 C 288.092,268.873 288.425,266.206 288.5,263.5C 289.552,263.351 290.552,263.517 291.5,264C 290.973,267.005 289.64,269.505 287.5,271.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aca8b4",
    d: "M 310.5,263.5 C 313.247,263.187 315.914,263.52 318.5,264.5C 317.311,265.429 315.978,265.762 314.5,265.5C 314.5,268.167 314.5,270.833 314.5,273.5C 313.448,273.649 312.448,273.483 311.5,273C 312.435,270.619 312.768,268.119 312.5,265.5C 310.007,265.869 309.34,265.203 310.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#645c73",
    d: "M 372.5,264.5 C 372.608,266.514 371.942,268.18 370.5,269.5C 369.596,270.209 369.263,271.209 369.5,272.5C 368.683,270.031 368.183,267.365 368,264.5C 367.502,267.482 367.335,270.482 367.5,273.5C 366.761,273.631 366.094,273.464 365.5,273C 366.108,271.769 366.441,270.436 366.5,269C 366.392,267.319 365.725,266.152 364.5,265.5C 365.492,263.974 366.992,263.307 369,263.5C 370.385,263.514 371.551,263.848 372.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#6c657b",
    d: "M 464.5,273.5 C 464.84,270.028 464.507,267.361 463.5,265.5C 462.957,265.44 462.624,265.107 462.5,264.5C 463.723,263.386 465.056,263.219 466.5,264C 465.167,267 465.167,270 466.5,273C 465.906,273.464 465.239,273.631 464.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bab6c1",
    d: "M 420.5,264.5 C 423.625,263.521 426.958,263.187 430.5,263.5C 430.569,266.084 431.735,268.084 434,269.5C 434.743,267.559 434.576,265.726 433.5,264C 434.833,263.333 436.167,263.333 437.5,264C 437.742,274.425 435.242,275.591 430,267.5C 429.257,269.441 429.424,271.274 430.5,273C 429.167,273.667 427.833,273.667 426.5,273C 427.777,270.534 427.777,268.034 426.5,265.5C 423.828,267.425 422.828,270.092 423.5,273.5C 422.448,273.649 421.448,273.483 420.5,273C 421.817,270.063 421.817,267.23 420.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c9c6ce",
    d: "M 439.5,266.5 C 440.306,267.997 440.972,269.664 441.5,271.5C 442.689,272.429 444.022,272.762 445.5,272.5C 446.575,269.823 446.575,270.823 445.5,275.5C 444.107,274.137 442.441,273.304 440.5,273C 438.166,271.158 437.832,268.991 439.5,266.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aba6b3",
    d: "M 459.5,265.5 C 458.348,264.375 457.348,264.375 456.5,265.5C 455.325,265.281 454.325,265.614 453.5,266.5C 452.94,268.854 452.273,271.187 451.5,273.5C 451.039,270.045 450.039,266.878 448.5,264C 451.468,264.026 454.302,263.859 457,263.5C 458.376,263.684 459.209,264.351 459.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1e0e4",
    d: "M 459.5,265.5 C 462.149,271.601 463.482,271.601 463.5,265.5C 464.507,267.361 464.84,270.028 464.5,273.5C 461.902,271.696 459.735,269.362 458,266.5C 457.719,269.097 457.552,271.43 457.5,273.5C 456.52,270.914 456.187,268.247 456.5,265.5C 457.348,264.375 458.348,264.375 459.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d2d0d6",
    d: "M 282.5,264.5 C 283.167,264.5 283.833,264.5 284.5,264.5C 284.552,267.346 285.552,269.68 287.5,271.5C 287.179,273.048 286.179,273.715 284.5,273.5C 284.992,269.71 284.159,269.044 282,271.5C 281.833,271.167 281.667,270.833 281.5,270.5C 282.348,268.591 282.682,266.591 282.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b6b2bd",
    d: "M 298.5,272.5 C 296.777,273.807 294.943,273.807 293,272.5C 291.758,266.114 294.258,263.281 300.5,264C 299.874,264.75 299.374,265.584 299,266.5C 297.817,265.269 296.651,265.269 295.5,266.5C 296.025,267.192 296.692,267.692 297.5,268C 293.423,270.359 293.757,271.859 298.5,272.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c7c4cd",
    d: "M 306.5,273.5 C 306.649,272.448 306.483,271.448 306,270.5C 301.212,267.72 301.379,265.387 306.5,263.5C 307.932,263.733 308.432,264.4 308,265.5C 306.578,265.594 305.078,265.928 303.5,266.5C 305.337,267.838 307.003,269.338 308.5,271C 308.361,272.301 307.695,273.134 306.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d1cfd6",
    d: "M 343.5,267.5 C 342.909,266.849 342.243,266.182 341.5,265.5C 341.957,264.702 342.624,264.369 343.5,264.5C 347.34,271.828 348.674,271.828 347.5,264.5C 348.365,263.417 349.365,263.251 350.5,264C 349.87,267.129 349.204,270.296 348.5,273.5C 346.359,271.878 344.692,269.878 343.5,267.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ccc9d1",
    d: "M 372.5,264.5 C 373.497,264.47 374.164,264.97 374.5,266C 374.05,267.285 373.383,268.452 372.5,269.5C 373.313,270.814 374.313,271.981 375.5,273C 374.365,273.749 373.365,273.583 372.5,272.5C 372.058,271.261 371.391,270.261 370.5,269.5C 371.942,268.18 372.608,266.514 372.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cbc9d0",
    d: "M 381.5,263.5 C 384.766,264.041 388.1,264.207 391.5,264C 390.398,266.401 390.231,268.901 391,271.5C 391.75,272.126 392.584,272.626 393.5,273C 391.888,273.72 390.388,273.554 389,272.5C 388.814,270.1 388.314,267.766 387.5,265.5C 386.813,267.274 385.98,268.941 385,270.5C 384.727,268.899 384.227,267.399 383.5,266C 381.892,265.342 380.725,265.842 380,267.5C 379.667,267.167 379.333,266.833 379,266.5C 377.643,270.143 378.81,272.31 382.5,273C 378,273.833 376.167,272 377,267.5C 377.907,265.391 379.407,264.058 381.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bdb9c3",
    d: "M 471.5,263.5 C 473.199,263.34 474.866,263.506 476.5,264C 475.874,264.75 475.374,265.584 475,266.5C 470.154,264.677 468.488,266.344 470,271.5C 471.011,272.337 472.178,272.67 473.5,272.5C 473.5,271.167 473.5,269.833 473.5,268.5C 474.675,268.281 475.675,268.614 476.5,269.5C 475.965,271.661 475.132,273.661 474,275.5C 466.478,272.757 465.645,268.757 471.5,263.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#d8d5db",
    d: "M 278.5,264.5 C 278.804,267.579 279.804,270.413 281.5,273C 280.552,273.483 279.552,273.649 278.5,273.5C 278.44,270.659 277.774,267.993 276.5,265.5C 276.842,264.662 277.508,264.328 278.5,264.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c8c5cd",
    d: "M 321.5,265.5 C 322.058,266.79 323.058,267.623 324.5,268C 320.453,270.277 320.786,271.944 325.5,273C 323.559,273.743 321.726,273.576 320,272.5C 319.725,269.942 320.225,267.608 321.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfbbc5",
    d: "M 364.5,265.5 C 364.631,266.239 364.464,266.906 364,267.5C 358.855,264.104 356.855,265.438 358,271.5C 359.011,272.337 360.178,272.67 361.5,272.5C 361.899,269.012 362.566,268.846 363.5,272C 363.491,273.404 362.991,274.57 362,275.5C 360.902,274.033 359.402,273.199 357.5,273C 354.493,268.167 355.827,265.001 361.5,263.5C 362.739,263.942 363.739,264.609 364.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#9a95a4",
    d: "M 306.5,273.5 C 306.134,274.695 305.301,275.361 304,275.5C 302.016,274.661 300.183,273.661 298.5,272.5C 298.369,271.624 298.702,270.957 299.5,270.5C 300.5,271.833 301.5,271.833 302.5,270.5C 303.506,270.938 303.506,271.604 302.5,272.5C 303.689,273.429 305.022,273.762 306.5,273.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b9b5c0",
    d: "M 413.5,265.5 C 415.473,267.301 417.139,269.301 418.5,271.5C 417.364,274.819 415.198,275.819 412,274.5C 411.219,273.056 411.386,271.723 412.5,270.5C 413.506,270.938 413.506,271.604 412.5,272.5C 414.307,273.799 415.973,273.632 417.5,272C 415.812,270.312 414.145,268.645 412.5,267C 412.57,266.235 412.903,265.735 413.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0deca",
    d: "M -0.5,278.5 C 3.18174,278.335 6.84841,278.501 10.5,279C 11.8333,281.333 11.8333,283.667 10.5,286C 6.84841,286.499 3.18174,286.665 -0.5,286.5C -0.5,283.833 -0.5,281.167 -0.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2e1cd",
    d: "M 18.5,278.5 C 22.5138,278.334 26.5138,278.501 30.5,279C 31.435,281.381 31.7683,283.881 31.5,286.5C 26.8333,286.5 22.1667,286.5 17.5,286.5C 17.2786,283.721 17.612,281.054 18.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfdcc9",
    d: "M 38.5,278.5 C 42.9017,278.228 47.2351,278.561 51.5,279.5C 52.641,281.421 52.8077,283.421 52,285.5C 47.5868,286.632 43.0868,286.799 38.5,286C 37.2215,283.502 37.2215,281.002 38.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dad5c4",
    d: "M 72.5,280.5 C 69.1309,282.515 65.7976,284.515 62.5,286.5C 57.622,286.465 56.2887,284.132 58.5,279.5C 62.777,278.394 67.1103,278.228 71.5,279C 72.056,279.383 72.3893,279.883 72.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b42a42",
    d: "M 78.5,279.5 C 83.1667,279.5 87.8333,279.5 92.5,279.5C 92.5,281.833 92.5,284.167 92.5,286.5C 87.8333,286.5 83.1667,286.5 78.5,286.5C 78.5,284.167 78.5,281.833 78.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b02c44",
    d: "M 98.5,279.5 C 103.5,279.5 108.5,279.5 113.5,279.5C 114.751,285.747 112.251,288.08 106,286.5C 99.7485,288.08 97.2485,285.747 98.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b52d44",
    d: "M 119.5,279.5 C 124.167,279.5 128.833,279.5 133.5,279.5C 133.756,281.792 133.423,283.959 132.5,286C 128.179,286.499 123.846,286.666 119.5,286.5C 119.5,284.167 119.5,281.833 119.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b73147",
    d: "M 139.5,279.5 C 144.167,279.5 148.833,279.5 153.5,279.5C 153.5,281.833 153.5,284.167 153.5,286.5C 148.833,286.5 144.167,286.5 139.5,286.5C 139.5,284.167 139.5,281.833 139.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b32a42",
    d: "M 174.5,282.5 C 172.611,283.604 170.945,284.937 169.5,286.5C 166.482,286.665 163.482,286.498 160.5,286C 159.577,283.959 159.244,281.792 159.5,279.5C 164.5,279.5 169.5,279.5 174.5,279.5C 174.5,280.5 174.5,281.5 174.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e6d0",
    d: "M 179.5,279.5 C 184.5,279.5 189.5,279.5 194.5,279.5C 195.751,285.747 193.251,288.08 187,286.5C 180.749,288.08 178.249,285.747 179.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeed6",
    d: "M 200.5,279.5 C 205.167,279.5 209.833,279.5 214.5,279.5C 214.5,281.833 214.5,284.167 214.5,286.5C 209.833,286.5 205.167,286.5 200.5,286.5C 200.5,284.167 200.5,281.833 200.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecead3",
    d: "M 235.5,282.5 C 233.833,283.5 232.5,284.833 231.5,286.5C 228.15,286.665 224.817,286.498 221.5,286C 220.577,283.959 220.244,281.792 220.5,279.5C 225.5,279.5 230.5,279.5 235.5,279.5C 235.5,280.5 235.5,281.5 235.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b42841",
    d: "M 241.5,279.5 C 246.167,279.5 250.833,279.5 255.5,279.5C 255.756,281.792 255.423,283.959 254.5,286C 250.179,286.499 245.846,286.666 241.5,286.5C 241.5,284.167 241.5,281.833 241.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ecead3",
    d: "M 282.5,279.5 C 287.167,279.5 291.833,279.5 296.5,279.5C 297.751,285.747 295.251,288.08 289,286.5C 282.329,288.003 280.163,285.669 282.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f1f0d7",
    d: "M 315.5,279.5 C 315.326,281.861 314.993,284.194 314.5,286.5C 310.5,286.5 306.5,286.5 302.5,286.5C 302.5,284.167 302.5,281.833 302.5,279.5C 306.833,279.5 311.167,279.5 315.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b82d45",
    d: "M 322.5,279.5 C 327.167,279.5 331.833,279.5 336.5,279.5C 336.5,281.833 336.5,284.167 336.5,286.5C 331.833,286.5 327.167,286.5 322.5,286.5C 322.5,284.167 322.5,281.833 322.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ba2e44",
    d: "M 349.5,279.5 C 349.5,281.5 349.5,283.5 349.5,285.5C 347.833,285.5 346.167,285.5 344.5,285.5C 344.5,283.5 344.5,281.5 344.5,279.5C 346.167,279.5 347.833,279.5 349.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e1deca",
    d: "M 349.5,279.5 C 352.5,279.5 355.5,279.5 358.5,279.5C 358.756,281.792 358.423,283.959 357.5,286C 354.633,286.801 351.966,286.634 349.5,285.5C 349.5,283.5 349.5,281.5 349.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e8d2",
    d: "M 364.5,279.5 C 369.167,279.5 373.833,279.5 378.5,279.5C 379.84,285.493 377.507,287.827 371.5,286.5C 365.493,287.827 363.16,285.493 364.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ad2a43",
    d: "M 384.5,279.5 C 389.167,279.5 393.833,279.5 398.5,279.5C 398.5,281.833 398.5,284.167 398.5,286.5C 394.154,286.666 389.821,286.499 385.5,286C 384.577,283.959 384.244,281.792 384.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b23147",
    d: "M 411.5,279.5 C 412.015,281.894 412.681,284.228 413.5,286.5C 410.833,286.5 408.167,286.5 405.5,286.5C 405.5,284.167 405.5,281.833 405.5,279.5C 407.5,279.5 409.5,279.5 411.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3dfcb",
    d: "M 411.5,279.5 C 414.167,279.5 416.833,279.5 419.5,279.5C 420.906,284.931 418.906,287.265 413.5,286.5C 412.681,284.228 412.015,281.894 411.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e7d1",
    d: "M 425.5,279.5 C 430.167,279.5 434.833,279.5 439.5,279.5C 439.5,281.833 439.5,284.167 439.5,286.5C 435.154,286.666 430.821,286.499 426.5,286C 425.577,283.959 425.244,281.792 425.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b22a42",
    d: "M 446.5,280.5 C 450.634,279.515 454.968,279.182 459.5,279.5C 459.5,281.833 459.5,284.167 459.5,286.5C 455.833,286.5 452.167,286.5 448.5,286.5C 447.465,284.795 447.465,283.128 448.5,281.5C 448.043,280.702 447.376,280.369 446.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b02b43",
    d: "M 466.5,279.5 C 471.167,279.5 475.833,279.5 480.5,279.5C 480.756,281.792 480.423,283.959 479.5,286C 475.179,286.499 470.846,286.666 466.5,286.5C 466.5,284.167 466.5,281.833 466.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b23146",
    d: "M 491.5,279.5 C 492.921,282.009 494.588,284.343 496.5,286.5C 493.482,286.665 490.482,286.498 487.5,286C 486.577,283.959 486.244,281.792 486.5,279.5C 488.167,279.5 489.833,279.5 491.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ece8d2",
    d: "M 491.5,279.5 C 494.5,279.5 497.5,279.5 500.5,279.5C 500.5,281.833 500.5,284.167 500.5,286.5C 499.167,286.5 497.833,286.5 496.5,286.5C 494.588,284.343 492.921,282.009 491.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3e1cd",
    d: "M 506.5,279.5 C 511.179,279.334 515.845,279.501 520.5,280C 521.576,281.726 521.743,283.559 521,285.5C 516.587,286.632 512.087,286.799 507.5,286C 506.577,283.959 506.244,281.792 506.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e8e6d1",
    d: "M 527.5,279.5 C 532.167,279.5 536.833,279.5 541.5,279.5C 541.756,281.792 541.423,283.959 540.5,286C 536.179,286.499 531.846,286.666 527.5,286.5C 527.5,284.167 527.5,281.833 527.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e6dfcc",
    d: "M 551.5,279.5 C 553.64,282.061 555.973,284.395 558.5,286.5C 554.833,286.5 551.167,286.5 547.5,286.5C 547.5,284.167 547.5,281.833 547.5,279.5C 548.833,279.5 550.167,279.5 551.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b52b42",
    d: "M 551.5,279.5 C 554.833,279.5 558.167,279.5 561.5,279.5C 561.5,281.833 561.5,284.167 561.5,286.5C 560.5,286.5 559.5,286.5 558.5,286.5C 555.973,284.395 553.64,282.061 551.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ae2841",
    d: "M 568.5,279.5 C 572.846,279.334 577.179,279.501 581.5,280C 582.576,281.726 582.743,283.559 582,285.5C 577.587,286.632 573.087,286.799 568.5,286C 567.232,283.837 567.232,281.67 568.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0263f",
    d: "M 588.5,279.5 C 593.167,279.5 597.833,279.5 602.5,279.5C 603.84,285.493 601.507,287.827 595.5,286.5C 589.493,287.827 587.16,285.493 588.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b2263f",
    d: "M 608.5,279.5 C 613.167,279.5 617.833,279.5 622.5,279.5C 622.5,281.833 622.5,284.167 622.5,286.5C 618.154,286.666 613.821,286.499 609.5,286C 608.577,283.959 608.244,281.792 608.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#af2a42",
    d: "M 629.5,279.5 C 633.846,279.334 638.179,279.501 642.5,280C 643.576,281.726 643.743,283.559 643,285.5C 638.587,286.632 634.087,286.799 629.5,286C 628.232,283.837 628.232,281.67 629.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ebe6d1",
    d: "M 652.5,279.5 C 656.167,279.5 659.833,279.5 663.5,279.5C 663.795,281.735 663.461,283.735 662.5,285.5C 658.799,283.988 655.466,281.988 652.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#edecd4",
    d: "M 669.5,279.5 C 674.167,279.5 678.833,279.5 683.5,279.5C 683.5,281.833 683.5,284.167 683.5,286.5C 679.154,286.666 674.821,286.499 670.5,286C 669.577,283.959 669.244,281.792 669.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e3e1cd",
    d: "M 692.5,278.5 C 696.514,278.334 700.514,278.501 704.5,279C 705.591,281.064 705.758,283.231 705,285.5C 700.587,286.632 696.087,286.799 691.5,286C 690.046,283.216 690.379,280.716 692.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e2e0cc",
    d: "M 712.5,278.5 C 716.514,278.334 720.514,278.501 724.5,279C 725.435,281.381 725.768,283.881 725.5,286.5C 720.833,286.5 716.167,286.5 711.5,286.5C 711.279,283.721 711.612,281.054 712.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#dfdcc9",
    d: "M 732.5,278.5 C 736.902,278.228 741.235,278.561 745.5,279.5C 746.641,281.421 746.808,283.421 746,285.5C 741.587,286.632 737.087,286.799 732.5,286C 731.221,283.502 731.221,281.002 732.5,278.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b83248",
    d: "M 261.5,279.5 C 266.167,279.5 270.833,279.5 275.5,279.5C 275.5,281.833 275.5,284.167 275.5,286.5C 270.833,286.5 266.167,286.5 261.5,286.5C 261.5,284.167 261.5,281.833 261.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a9525e",
    d: "M 315.5,279.5 C 316.152,280.449 316.486,281.615 316.5,283C 316.392,284.681 315.725,285.848 314.5,286.5C 314.993,284.194 315.326,281.861 315.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b43247",
    d: "M 652.5,279.5 C 655.466,281.988 658.799,283.988 662.5,285.5C 658.689,286.645 654.689,286.812 650.5,286C 649.577,283.959 649.244,281.792 649.5,279.5C 650.5,279.5 651.5,279.5 652.5,279.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1354b",
    d: "M 72.5,280.5 C 72.7394,282.467 72.4061,284.301 71.5,286C 68.5184,286.498 65.5184,286.665 62.5,286.5C 65.7976,284.515 69.1309,282.515 72.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b14959",
    d: "M 235.5,282.5 C 235.833,285.5 234.5,286.833 231.5,286.5C 232.5,284.833 233.833,283.5 235.5,282.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#bfa8aa",
    d: "M 446.5,280.5 C 447.376,280.369 448.043,280.702 448.5,281.5C 447.465,283.128 447.465,284.795 448.5,286.5C 448.5,287.5 448.5,288.5 448.5,289.5C 448.167,289.5 447.833,289.5 447.5,289.5C 447.085,287.253 446.418,285.086 445.5,283C 445.528,281.93 445.861,281.097 446.5,280.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#c7baaf",
    d: "M 174.5,282.5 C 174.616,285.91 172.95,287.244 169.5,286.5C 170.945,284.937 172.611,283.604 174.5,282.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcordianew);
export default __webpack_public_path__ + "static/media/concordianew.4a10ab7b43ac4db955f9dc94be549ccc.svg";
export { ForwardRef as ReactComponent };